import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { CheckClosingYearD } from "../../ShortFunction/CheckClosingYearD";
import CreatableSelect from "react-select/creatable";

import {
  Button,
  Col,
  Form,
  Row,
  Input,
  Label,
  InputGroupAddon,
  FormGroup,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import moment from "moment";
import BankAdd from "../../BackTransfer/BackCreate/BackAdd";
import CloseButton from "react-bootstrap/CloseButton";
import {
  checkPermission,
  check_Bussiness_Permission,
} from "../../../../Helper";
import { Modal } from "react-bootstrap";
import "./baseForms.css";
import DatePicker from "react-datepicker";
import { Redirect, Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import Abc from "../../../../containers/DefaultLayout/Home";
import "./myReactSelect.css";
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from "react-number-format";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import ClientForm from "../../ShortCutComponents/ClientForm";
import ItemLoadComponent from "../../ShortCutComponents/ItemForm";
import PaymentHistoryComponent from "../../ShortCutComponents/PaymentHistoryComponent";
import BranchDynamicLov from "../../ShortCutComponents/BranchDynamicLov";
import tooltipText from "../../ShortCutComponents/tooltipText";
import { GetIp } from "../../ShortCutComponents/Get_ip";
var thisContex;
var token = localStorage.getItem("token");
var select = localStorage.getItem("select");

var companyId = localStorage.getItem("companyId");
var companyName = localStorage.getItem("companyName");
let curDescTemp = localStorage.getItem("companySymbol");
let currencyId = localStorage.getItem("currencyId");
let username = localStorage.getItem("username");
let firstName = localStorage.getItem("firstName");

const handleSubmitAddNew = async (e) => {
  e.preventDefault();

  var token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  let companyID = localStorage.getItem("companyId");

  thisContex.setState({
    loadingResponce: true,
  });

  const {
    invoice_ref_no,
    invoice_date,
    builtyno,
    builtyDate,
    career,
    filerYn,
    cat_id,
    beenPaid,
    currency_Id,
    due_date,
    customer_id,
    payment_term_id,
    remarks,
    conv_Rate,
    formValues,
    // pushDeleteArray,
    totalnet,
    invNetTotal,
    filerTaxAmt,
    totaldiscount,
    totalamount,
    customerName,
    customerEmail,
    invoiceNumber,
    journalId,
    jrArray,
    pONumber,
    inv_book_id,
    copyData,
    emailServerPassword,
    emailServerUsername,
    userIp,
    userCountry,
    agentCode,
    agentName,
    agentContract,
    agentRTNo,
    agentTruckNo,
    isNayyer,
    fbr_inv_check,
  } = thisContex.state;

  if (customer_id === undefined || customer_id === "" || !customer_id?.id) {
    swal({
      title: "Client",
      text: "Please Enter Client",
      icon: "error",
    });
    thisContex.setState({
      loadingResponce: false,
    });
  } else if (totalnet < 0) {
    swal({
      title: "Some Issue",
      text: "May be net amount is negative for some reason.",
      icon: "error",
    });
    thisContex.setState({
      loadingResponce: false,
    });
  } else if (cat_id === null && beenPaid) {
    // swal({
    //   title: "Some Issue",
    //   text: "May be net amount is negative for some reason.",
    //   icon: "error",
    // });
    thisContex.setState({
      loadingResponce: false,
      catError: true,
    });
  } else {
    let condSubmit = copyData ? false : thisContex.props.location.state?.id;
    if (condSubmit) {
      let formValues2 = formValues;
      let checkSalesTaxError = false;
      let sumSaleTaxVal = 0;
      for (let i = 0; i < formValues.length; i++) {
        console.log(
          'formValues2[i]["item_id"] :>> ',
          formValues2[i]["item_id"]
        );
        if (
          formValues2[i]["item_id"] == 0 ||
          formValues2[i]["item_id"] == null ||
          !formValues2[i]["item_id"]?.id
        ) {
          swal({
            title: "Item",
            text: "Please Enter Item",
            icon: "error",
          });
          thisContex.setState({
            loadingResponce: false,
          });
        }
        sumSaleTaxVal += +formValues2[i]["stVal"];
        formValues2[i]["netAmount"] = formValues2[i]["netAmount"]
          .toString()
          .replaceAll(",", "");
        formValues2[i]["saleTaxID"] = formValues2[i]["saleTax"];
        console.log(
          ' formValues2[i]["item_id"] == 0  :>> ',
          formValues2[i]["item_id"] == 0
        );
        if (
          // formValues2[i]["item_id"] == 0 ||
          formValues2[i]["qty"] <= 0 ||
          formValues2[i]["rate"] <= 0
        ) {
          checkSalesTaxError = true;
          break;
        }
      }
      let date = moment(invoice_date).format("YYYY-MM-DD");
      let invoiceId = thisContex.props.location.state?.id;
      let singleItemArray = []; 
    await  axios
        .post(
          `${baseurl}/masterData/getInvoiceDataWithId`,
          {
            id: invoiceId,
            idJ: journalId,
            alqadirCheck: companyName === "Al_Qadir" ? true : false,
            username: username,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          var dataResponse = response.data.data1;
          var res_mt = response.data.data[0];
          let  fbr_post_at = res_mt["status"]; 
            
      ///////////////////////////////////  
 
if(fbr_inv_check && fbr_post_at){

      thisContex.setState({
      loadingResponce: false,
    });
     swal({
      title: "FBR Posted",
      text: "Not Updated.",
      icon: "warning",
    });
    return
}
      ///////////////////////////////////
          for (var i = 0; i < dataResponse.length; i++) {
            var itemId = dataResponse[i]["ITEM_ID"];
            var itemCode = dataResponse[i]["ITEM_CODE"];
            singleItemArray.push({
              item_id: itemId,
              itemCode: itemCode,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      // console.log("singleItemArray", singleItemArray);
      let uniqueSingleItem = [];
      let uniqueSingleCode = [];
      Array.prototype.push.apply(singleItemArray, formValues2);
      const uniqueItem = [
        ...new Set(singleItemArray.map((item) => item["item_id"])),
      ];
      // console.log("uniqueItem------", uniqueItem);
      const uniqueCode = [
        ...new Set(singleItemArray.map((item) => item["itemCode"])),
      ];
      // console.log("uniqueCode------", uniqueCode);

      uniqueItem.map((item) =>
        uniqueSingleItem.push({
          item_id: item?.id,
        })
      );
      console.log("uniqueCode :>> ", uniqueCode);
      uniqueCode.map((item) =>
        uniqueSingleCode.push({
          itemCode: item,
        })
      );

      if (!checkSalesTaxError) {
        axios
          .post(
            `${baseurl}/masterData/updateInvoice`, 
            {
              companyId: companyID,
              invoice_ref_no: invoice_ref_no,
              pONumber: pONumber,
              invoice_date: date,
              currency_Id: currency_Id,
              builtyno: builtyno,
              builtyDate: moment(builtyDate).format("YYYY-MM-DD"),
              career: career?.id,
              filerYn: filerYn?.id,
              branchLov:
                thisContex.state.dynamicLovVal.id ||
                thisContex.state.defaultLovVal,
              due_date: due_date,
              customer_id: customer_id?.id,
              customerName: customerName,
              payment_term_id: payment_term_id,
              remarks: remarks || null,
              bankId: cat_id?.acct_id,
              beenPaid: beenPaid,
              conv_Rate: conv_Rate,
              invoiceId: invoiceId,
              detailArray: formValues2,
              uniqueSingleItem: uniqueSingleItem,
              uniqueSingleCode: uniqueSingleCode,
              arr_jrn_det: jrArray,
              sumSaleTaxVal: sumSaleTaxVal,
              totalnet: totalnet.toString().replaceAll(",", ""),
              totaldiscount: totaldiscount.toString().replaceAll(",", ""),
              totalamount: totalamount.toString().replaceAll(",", ""),
              invNetTotal: invNetTotal.toString().replaceAll(",", ""),
              filerTaxAmt: filerTaxAmt.toString().replaceAll(",", ""),
              documentNo: invoiceNumber,
              alqadirCheck: companyName === "Al_Qadir" ? true : false,
              agentCode: agentCode || null,
              agentName: agentName || null,
              agentContract: agentContract || null,
              agentRTNo: agentRTNo || null,
              agentTruckNo: agentTruckNo || null,
              journalId,
              username: username,
              userIp,
              userCountry,
              inv_book_id,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            let resMessage = response.data.message;

            let resDate = response.data.resDate;

            let itemCode = response.data.itemCode;

            thisContex.setState({
              loadingResponce: false,
            });
            if (resMessage == "Negavtive Item") {
              swal({
                title: `Item of code ${itemCode} is being negetive on ${resDate}`,
                text: "issue",
                icon: "error",
              });
              thisContex.setState({
                loadingResponce: false,
              });
              // thisContex.toggle();
            } else {
              swal({
                title: "Updated Successfully!",
                text: "Invoice Submitted ",
                icon: "success",
              }).then((value) => {
                if (!journalId) {
                  thisContex.toggle();
                }

                thisContex.setState({
                  isActive: !thisContex.state.isActive,
                  disabled: !thisContex.state.disabled,
                  masterId: thisContex.props.location.state?.id,
                });
                thisContex.props.location.state.id = null;
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            
            swal({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
            thisContex.setState({
              loadingResponce: false,
            });
          });
      } else {
        swal({
          title: "Some Issue",
          text: "May be something is zero or empty, please recheck",
          icon: "error",
        });
        thisContex.setState({
          loadingResponce: false,
        });
      }
    } else {
      let formValues2 = formValues;
      let sumSaleTaxVal = 0;
      let checkSalesTaxError = false;

      for (let i = 0; i < formValues.length; i++) {
        console.log(
          'formValues2[i]["item_id"] Add:>> ',
          formValues2[i]["item_id"]
        );
        sumSaleTaxVal += +formValues2[i]["stVal"];
        formValues2[i]["netAmount"] = formValues2[i]["netAmount"]
          .toString()
          .replaceAll(",", "");
        formValues2[i]["saleTaxID"] = formValues2[i]["saleTax"];

        // lets do 4 decimal work
        formValues2[i]["qty"] = formValues2[i]["qty"];
        formValues2[i]["rate"] = formValues2[i]["rate"];
        formValues2[i]["amount"] = formValues2[i]["amount"];
        formValues2[i]["discount"] = formValues2[i]["discount"];
        formValues2[i]["netAmount"] = formValues2[i]["netAmount"];

        if (formValues2[i]["qty"] <= 0 || formValues2[i]["rate"] <= 0) {
          checkSalesTaxError = true;

          break;
        } else if (!formValues2[i]["item_id"]?.id) {
          swal({
            title: "Item",
            text: "Please Enter Item",
            icon: "error",
          });
          thisContex.setState({
            loadingResponce: false,
          });
        }
      }

      if (!checkSalesTaxError) {
        let date = moment(invoice_date).format("YYYY-MM-DD");
        axios
          .post(
            `${baseurl}/masterData/getAddInvoice`,
            {
              companyId: companyID,
              invoice_ref_no: invoice_ref_no,
              pONumber: pONumber,
              invoice_date: date,
              builtyno: builtyno,

              builtyDate: moment(builtyDate).format("YYYY-MM-DD"),
              career: career?.id,
              filerYn: filerYn?.id,
              currency_Id: currency_Id,
              branchLov:
                thisContex.state.dynamicLovVal.id ||
                thisContex.state.defaultLovVal,
              due_date: due_date,
              customer_id: customer_id?.id,
              customerName: customerName,
              customerEmail: customerEmail,
              payment_term_id: payment_term_id,
              remarks: remarks || null,
              emailServerPassword: emailServerPassword,
              emailServerUsername: emailServerUsername,
              conv_Rate: conv_Rate,
              detailArray: formValues2,
              bankId: cat_id?.acct_id,
              bankIdPK: cat_id?.id,
              beenPaid: beenPaid,
              arr_jrn_det: jrArray,
              sumSaleTaxVal: sumSaleTaxVal,
              totalnet: totalnet.toString().replaceAll(",", ""),
              totaldiscount: totaldiscount.toString().replaceAll(",", ""),
              totalamount: totalamount.toString().replaceAll(",", ""),
              invNetTotal: invNetTotal.toString().replaceAll(",", ""),
              filerTaxAmt: filerTaxAmt.toString().replaceAll(",", ""),
              alqadirCheck: companyName === "Al_Qadir" ? true : false,
              agentCode: agentCode || null,
              agentName: agentName || null,
              agentContract: agentContract || null,
              agentRTNo: agentRTNo || null,
              agentTruckNo: agentTruckNo || null,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            let resMessage = response.data.message;

            let resDate = response.data.resDate;

            let itemCode = response.data.itemCode;

            thisContex.setState({
              loadingResponce: false,
            });
            if (resMessage == "Negavtive Item") {
              swal({
                title: `Item of code ${itemCode} is being negetive on ${resDate}`,
                text: "issue",
                icon: "error",
              });
              thisContex.setState({
                loadingResponce: false,
              });
              if (companyName === "Al_Qadir") {
              } else {
                this.toggle();
              }
            } else {
              var inv_doc_no = response.data.inv_doc_no;

              thisContex.setState({
                loadingResponce: false,
                invoiceNumber: inv_doc_no,
              });
              swal({
                title: "Saved Successfully!",
                text: "Invoice Submitted ",
                icon: "success",
              }).then((value) => {
                if (companyName === "Al_Qadir") {
                  thisContex.modelLinkButton(response.data.masterId);
                } else {
                  thisContex.toggle();
                }
                thisContex.setState({
                  isActive: !thisContex.state.isActive,
                  disabled: !thisContex.state.disabled,
                  masterId: response.data.masterId,
                  loadingResponce: false,
                });
              });
            }
          })
          .catch(function (error) {
            thisContex.setState({
              loadingResponce: false,
            });
            // swal({
            //   title: "Invalid!",
            //   text: "Enter Client Mail Not Correct",
            //   icon: "error",
            // });
            // thisContex.getLovsLoad();

            console.log(error);
          });
      } else {
        swal({
          title: "Some Issue",
          text: "May be something is zero or empty please reachek",
          icon: "error",
        });
        thisContex.setState({
          loadingResponce: false,
        });
        // console.log("in axio else");
      }
    }
  }
};
const getUserIp = async function () {
  let res = await GetIp();

  thisContex.setState({
    userIp: res.ip,
    userCountry: res.country,
  });
};
/////////////////////////////-------------------ClassComponents Start Here----------///////////////////////////
class CreativeInvoice extends Component {
  constructor(props) {
    super(props);
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.toggleAddNewItem = this.toggleAddNewItem.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.paymentHistoryLoad = this.paymentHistoryLoad.bind(this);

    this.toggle = this.toggle.bind(this);
    let tempLogedIn = false;
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }
    let defaultdate = new Date();

    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      language: "en",
      clientUrdu: "کلائنٹ",
      showPrintButton: false,
      disabled: false,
      logInStaOpen: false,
      divcontainer: false,
      addBankToggle: false,
      lineNumber: 1,
      showModal: false,
      isLoadedlovPaymentsTerms: false,
      isLoadedlovCurrency: false,
      itus: tempLogedIn,
      customerEmail: "",
      showModalAddNew: false,
      showModalAddNewItem: false,
      loadingResponce: false,
      responseDataMain: [],
      defaultSalesTaxOptions: [],
      showModalsLoadedlovItem: false,
      isLoadedlovSaleTax: false,
      showPaymentHistory: false,
      emailPrefference: false,
      paymentsTermsLov: "",
      emailServerUsername: "",
      emailServerPassword: "",
      isActive: "",
      currencyLov: "",
      itemLov: "",
      saleTaxLov: "",
      clientLov: "",
      clientAdd: "",
      itemAdd: "",
      totalqty: 0,
      totalamount: 0,
      totaldiscount: 0,
      permission: true,
      copyInvperm: false,
      totalnet: 0,
      filerTax: 0,
      invNetTotal: 0,
      filerTaxAmt: 0,
      hideShowDiv: "",
      customerName: "",
      showItemForm: false,
      formName: "CREATE INVOICE",
      backToOverView: "BACK TO OVERVIEW",
      client: "Customer",
      IssueDate: "IssueDate",
      poNo: "poNo",
      refference: "Your Reff",
      CurrencyName: "Currency",
      note: "note",
      beenPaidText: "Paid?",
      paymentTerms: "Payment Terms",
      itemName: "Item",
      qtyName: "Quantity",
      rateName: "Rate",
      amountName: "Amount",
      discountName: "Discount",
      netAmountName: "Net Amount",
      descriptionName: "Description",
      saleTaxName: "Sale Tax",
      Invoice: "Invoice",
      labelBranchLov: "",
      showBranchLov: false,
      dynamicLovVal: [],
      defaultLovVal: "",
      pushDeleteArray: [],
      formValues: [
        {
          item_id: 0,
          itemCode: 0,
          uom_id: 0,
          saleTax: 0,
          saleTaxRate: 0,
          qty: 0,
          rate: 0,
          amount: 0,
          discount: 0,
          netAmount: 0,
          millNo: 1,

          desc: "",
          lineNum: 1,
          stVal: 0,
          saleTaxID: "",
          rateError: "",
          qtyError: "",
          amountError: "",
          discountError: "",
          netAamountError: "",
        },
      ],
      jrArray: [],
      paid: 0,
      currency_Id: currencyId,
      filerYn: null,
      current_currency_Id: currencyId,
      curDesc: curDescTemp,
      beenPaid: 0,
      isLoadedlovServiceDept: false,
      isLoadedlovNature: false,
      isLoadedQuickSearch: false,
      invoice_date: defaultdate,
      postYn: -1,
      sumSaleTaxVal: 0,
      conv_Rate: 1,
      RateError: false,
      QuantityError: false,
      ItemError: false,
      hideHasBeen: false,
      catError: false,
      cat_id: null,
      after_date: defaultdate,
      agentCode: "",
      agentName: "",
      agentContract: "",
      agentRTNo: "",
      agentTruckNo: "",
      agentTruckNo: null,
    };
    thisContex = this;
    console.log("mri props", this.props);
  }

  ////////////--------------Hande change for Form Submit------Start-------//////////////
  handleMessageBox(i, e) {
    let formValues = this.state.formValues;
    formValues[i][e.target.name] = e.target.value + "\r\n";

    if (e.key === "Enter") {
      this.setState({
        formValues,
      });
    }
  }
  newLinefunNotes(e) {
    if (e.key === "Enter") {
      this.setState({
        [e.target.name]: e.target.value + "\r\n",
      });
    }
  }
  handleChange = (e) => {
    if (e.target.name === "beenPaid") {
      if (e.target.value === "1") {
        let new_dueDate = new Date(this.state.invoice_date);
        this.setState({
          [e.target.name]: e.target.value,
          empYN: true,
          bankYN: true,
          payment_term_id: 1,

          due_date: new_dueDate,
        });
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          cat_id: "",
          catError: false,
        });
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };
  onChangeDatePicker = async (e) => {
    let invoiceDate = this.state.invoice_date;
    if (invoiceDate) {
      this.checkDateOfYear(invoiceDate);
    }
  };
  funPrintView = (e) => {
    this.setState({
      invoiceId: thisContex.props.location.state?.id,

      companyId: companyId,
      redirectToPrint: 1,
      headerPrefix: thisContex.props?.location?.state?.headerPrefix,
    });
  };
  toggleAddBankModel = () => {
    this.setState({
      addBankToggle: !this.state.addBankToggle,
    });
  };
  paymentHistoryLoad = (e) => {
    this.setState({
      showPaymentHistory: !this.state.showPaymentHistory,
    });
  };

  copyData = (e) => {
    this.onChangeDatePicker();
    this.setState({
      copyData: true,
      disabled: false,
    });
  };
  handleChangeLovsSelect = (customer_id) => {
    console.log("customer_id", customer_id);
    this.setState({
      customer_id,
      customerName: customer_id?.label,
      customerEmail: customer_id?.email,
      code_nic: customer_id?.CUSTOMER_CODE + " || " + customer_id?.cnic,
    });
  };
  handleChangeBankLovs = (cat_id) => {
    let catError = this.state.catError;
    if (cat_id) {
      catError = false;
    } else {
      catError = true;
    }
    thisContex.setState({
      cat_id,
      catError,
    });
  };

  handleCreate = async (inputValue, Name) => {
    this.setState({ isLoading: true });
    axios
      .post(
        `${baseurl}/masterData/AddCarrierFromLov`,
        {
          carrierName: inputValue,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        thisContex.refreshData();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        thisContex.setState({ isLoading: false });
      });
  };
  handleChangeCarrierLovs = (e) => {
    console.log("e", e);
    if (e) {
      thisContex.setState({
        career: e,
      });
    }
  };

  handleChangeFilerLovs = (e) => {
    console.log("e", e);

    if (e) {
      thisContex.setState(
        {
          filerYn: e,
          filerTax: e?.value,
        },
        () => {
          // ✅ This runs AFTER state update
          this.state.formValues.forEach((_, i) => {
            this.handleChangeItem(i, e);
          });
        }
      );
    }
  };

  handleChangeLovs = (e) => {
    console.log("e", e);
    if (e.target.name === "client") {
      thisContex.setState({
        customer_id: e.target.value,
      });
    } else if (e.target.name === "payment_term_id") {
      let paymentIndex = thisContex.state.paymentsTermsLov?.findIndex(function (
        element
      ) {
        return element.PAYMENT_TERM_ID == e.target.value;
      });
      let noOfDays = thisContex.state.paymentsTermsLov[paymentIndex].NO_OF_DAYS;
      let billDate = thisContex.state.invoice_date;
      // console.log("noOfDays", noOfDays);
      let date = new Date(billDate);
      date.setDate(date.getDate() + noOfDays);

      thisContex.setState({
        payment_term_id: e.target.value,
        after_date: date,
      });
    } else if (e.target.name === "currency_Id") {
      let curDesc = "";
      const { currencyLov } = thisContex.state;
      for (let index = 0; index < currencyLov.length; index++) {
        if (currencyLov[index].CURRENCY_ID === parseInt(e.target.value)) {
          curDesc = currencyLov[index].CURRENCY_SYMBOL;
        }
      }

      thisContex.setState({
        currency_Id: e.target.value,
        conv_Rate: 1,
        curDesc: curDesc,
      });
    } else if (e.target.name === "invoice_date") {
      thisContex.setState({
        invoice_date: e.target.value,
      });
    } else if (e.target.name === "career") {
      thisContex.setState({
        career: e.target.value,
      });
    }
  };
  // checkDiscountVlidation(i, e) {
  //   let formValues = this.state.formValues;
  //   let totalnet = 0;
  //   let totaldiscount = 0;
  //
  //   if (parseFloat(e.target.value) > parseFloat(formValues[i]["amount"])) {
  //     formValues[i]["discountError"] = "Discount cannot be greater than amount";
  //     formValues[i][e.target.name] = 0;
  //     totalnet = parseFloat(totalnet) + parseFloat(formValues[i]["netAmount"]);
  //     totaldiscount = 0;
  //     formValues[i]["netAmount"] = formValues[i]["amount"];
  //   } else {
  //     formValues[i]["netAmount"] = formValues[i]["netAmount"];
  //     for (let index = 0; index < formValues.length; index++) {
  //       totalnet =
  //         parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);
  //       totaldiscount =
  //         parseFloat(totaldiscount) + parseFloat(formValues[index]["discount"]);
  //     }

  //     //totalnet = parseFloat(totalnet) + parseFloat(formValues[i]["netAmount"]);
  //     formValues[i][e.target.name] = e.target.value;
  //     formValues[i]["discountError"] = "";
  //   }
  //   this.setState({
  //     formValues,
  //     totalnet,
  //     totaldiscount,
  //   });
  // }
  //////////////////////////////Items//////////////////////////////
  //ma ny modify kia
  //  handleChangeItem(i, e) {
  //     let formValues = this.state.formValues;
  //     let totalqty = 0;
  //     let totalamount = 0;
  //     let totaldiscount = 0;
  //     let totalnet = 0;
  //     let saleTaxLov = this.state.saleTaxLov;
  //     let netAmountSt = 0;

  //     let name = e.target.name;
  //     formValues[i]["amount"] = formValues[i]["amount"]
  //       ?.toString()
  //       ?.replaceAll(",", "");
  //     if (e.target.value < 0 || e.target.value === "-") {
  //       if (name === "qty") {
  //         formValues[i]["qtyError"] = "Negative values not allowed";
  //       } else if (name === "rate") {
  //         formValues[i]["rateError"] = "Negative values not allowed";
  //       } else if (name === "amount") {
  //         formValues[i]["amountError"] = "Negative values not allowed";
  //       } else if (name === "discount") {
  //         formValues[i]["discount"] = 0;
  //         formValues[i]["discountError"] = "Negative values not allowed";
  //         for (let index = 0; index < formValues.length; index++) {
  //           totaldiscount =
  //             parseFloat(totaldiscount) +
  //             parseFloat(formValues[index]["discount"]);
  //         }

  //         e.target.value = "";
  //         formValues[i]["discountError"] = "Discount cannot be greater than amount";
  //         this.setState({
  //           totaldiscount,
  //         });
  //       }
  //       formValues[i][e.target.name] = 0;
  //       this.setState({
  //         formValues,
  //       });
  //     } else {
  //       let currentValue = e.target.value?.toString().replaceAll(",", "");
  //       if (
  //         // e.target.name === "discount" &&
  //         e.target.value === "" ||
  //         e.target.value === "-"
  //         // parseFloat(currentValue) > parseFloat(formValues[i]["amount"])
  //       ) {
  //         formValues[i]["discount"] = 0;
  //         formValues[i]["amount"] = 0;
  //         formValues[i]["qty"] = 0;
  //         formValues[i]["rate"] = 0;
  //         formValues[i]["netAmount"] = 0;
  //         let totalqty = 0;
  //         let totalamount = 0;
  //         let totaldiscount = 0;
  //         let totalnet = 0;

  //         // for (let index = 0; index < formValues.length; index++) {
  //         //   totaldiscount =
  //         //     parseFloat(totaldiscount) +
  //         //     parseFloat(formValues[index]["discount"]);
  //         // }
  //         for (let index = 0; index < formValues.length; index++) {
  //           // formValues[index]["qty"] = formValues[index]["qty"]
  //           //   .toString()
  //           //   .replaceAll(",", "");
  //           // formValues[index]["amount"] = formValues[index]["amount"]
  //           //   .toString()
  //           //   .replaceAll(",", "");
  //           // formValues[index]["discount"] = formValues[index]["discount"]
  //           //   .toString()
  //           //   .replaceAll(",", "");
  //           // formValues[index]["netAmount"] = formValues[index]["netAmount"]
  //           //   .toString()
  //           //   .replaceAll(",", "");
  //           // if (formValues[index]["netAmount"] < 0) {
  //           //   formValues[index]["qty"] = "";
  //           //   formValues[index]["rate"] = "";
  //           //   formValues[index]["netAamountError"] =
  //           //     "May Be Discount is greater than Amount";
  //           // } else {
  //           //   formValues[index]["netAamountError"] = "";
  //           // }
  //           totalqty =
  //             parseFloat(totalqty) + parseFloat(formValues[index]["qty"]);
  //           totalamount =
  //             parseFloat(totalamount) + parseFloat(formValues[index]["amount"]);
  //           totaldiscount =
  //             parseFloat(totaldiscount) +
  //             parseFloat(formValues[index]["discount"]);
  //           totalnet =
  //             parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);
  //         }

  //         totalqty = totalqty.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         totalamount = totalamount
  //           .toString()
  //           ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         totaldiscount = totaldiscount
  //           .toString()
  //           ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         totalnet = totalnet.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         // e.target.value = "";
  //         formValues[i]["discountError"] = "Cannot Discount greater than amount";
  //         this.setState({
  //           formValues,
  //           totaldiscount,
  //         });
  //       } else {
  //         formValues[i]["discountError"] = "";

  //         formValues[i][e.target.name] = e.target.value;
  //         formValues[i]["qty"] = formValues[i]["qty"]
  //           .toString()
  //           .replaceAll(",", "");

  //         formValues[i]["rate"] = formValues[i]["rate"]
  //           .toString()
  //           .replaceAll(",", "");
  //         formValues[i]["netAmount"] = formValues[i]["netAmount"]
  //           .toString()
  //           .replaceAll(",", "");
  //         formValues[i]["discount"] = formValues[i]["discount"]
  //           .toString()
  //           .replaceAll(",", "");

  //         let targetValue = e.target.value.toString().replaceAll(",", "");
  //         if (e.target.name === "qty" && formValues[i]["amount"]) {
  //           formValues[i]["rate"] = (
  //             formValues[i]["amount"] / targetValue
  //           ).toFixed(4);
  //         } else if (e.target.name === "amount" && formValues[i]["qty"]) {
  //           formValues[i]["rate"] = (targetValue / formValues[i]["qty"]).toFixed(
  //             2
  //           );
  //         } else if (e.target.name === "qty" && formValues[i]["rate"]) {
  //           formValues[i]["amount"] = formValues[i]["rate"] * targetValue;
  //         } else if (e.target.name === "rate" && formValues[i]["qty"]) {
  //           formValues[i]["amount"] = formValues[i]["qty"] * targetValue;
  //         } else if (
  //           e.target.name === "discount" &&
  //           formValues[i]["amount"] &&
  //           targetValue > 0
  //         ) {
  //           formValues[i]["netAmount"] = formValues[i]["amount"] - targetValue;
  //         }

  //         if (formValues[i]["amount"]) {
  //           if (formValues[i]["discount"]) {
  //             formValues[i]["netAmount"] =
  //               formValues[i]["amount"] - formValues[i]["discount"];
  //           }

  //           for (let index = 0; index < saleTaxLov.length; index++) {
  //             if (
  //               formValues[i]["saleTax"] == saleTaxLov[index]["STAX_GROUP_ID"]
  //             ) {
  //               if (formValues[i]["netAmount"]) {
  //                 netAmountSt =
  //                   (parseFloat(formValues[i]["netAmount"]) *
  //                     parseFloat(saleTaxLov[index].STAX_RATE)) /
  //                   100;
  //                 formValues[i]["stVal"] = netAmountSt;
  //                 formValues[i]["netAmount"] =
  //                   parseFloat(formValues[i]["netAmount"]) +
  //                   parseFloat(netAmountSt);
  //               }
  //             }
  //           }
  //         }

  //         for (let index = 0; index < formValues.length; index++) {
  //           formValues[index]["qty"] = formValues[index]["qty"]
  //             .toString()
  //             .replaceAll(",", "");
  //           formValues[index]["amount"] = formValues[index]["amount"]
  //             .toString()
  //             .replaceAll(",", "");
  //           formValues[index]["discount"] = formValues[index]["discount"]
  //             .toString()
  //             .replaceAll(",", "");
  //           formValues[index]["netAmount"] = formValues[index]["netAmount"]
  //             .toString()
  //             .replaceAll(",", "");
  //           if (formValues[index]["netAmount"] < 0) {
  //             formValues[index]["qty"] = "";
  //             formValues[index]["rate"] = "";
  //             formValues[index]["netAamountError"] =
  //               "May Be Discount is greater than Amount";
  //           } else {
  //             formValues[index]["netAamountError"] = "";
  //           }
  //           totalqty =
  //             parseFloat(totalqty) + parseFloat(formValues[index]["qty"]);
  //           totalamount =
  //             parseFloat(totalamount) + parseFloat(formValues[index]["amount"]);
  //           totaldiscount =
  //             parseFloat(totaldiscount) +
  //             parseFloat(formValues[index]["discount"]);
  //           totalnet =
  //             parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);
  //         }

  //         totalqty = totalqty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         totalamount = totalamount
  //           .toString()
  //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         totaldiscount = totaldiscount
  //           .toString()
  //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         totalnet = totalnet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  //         // totalqty = totalqty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         // totalamount = totalamount
  //         //   .toString()
  //         //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         // totaldiscount = totaldiscount
  //         //   .toString()
  //         //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         // totalnet = totalnet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  //         let sumSaleTaxVal = 0;
  //         for (let i = 0; i < formValues.length; i++) {
  //           sumSaleTaxVal += +formValues[i]["stVal"];
  //         }
  //         formValues[i]["qtyError"] = "";
  //         formValues[i]["rateError"] = "";
  //         formValues[i]["amountError"] = "";

  //         this.setState({
  //           formValues,
  //           totalqty,
  //           totalamount,
  //           totaldiscount,
  //           totalnet,
  //           sumSaleTaxVal: sumSaleTaxVal,
  //           // qtyError: "",
  //           // rateError: "",
  //           // amountError: "",
  //           // discountError: "",
  //         });
  //       }
  //     }
  //   }

  handleChangeDetLovs = (index, e, name) => {
    console.log("selectLov", e.target.value);
    console.log("name", name);
    let lovName = name;
    // console.log("value", e.target.value);

    let formValues = this.state.formValues;
    console.log("formValues :>> ", formValues);
    if (e === null) {
      formValues[index]["millNo"] = null;
    }
    formValues[index]["millNo"] = e.target.value;

    console.log("formValues :>> ", formValues);

    this.setState({ formValues });
  };

  handleChangeItem(i, e) {
    let formValues = this.state.formValues;
    let totalqty = 0;
    let totalamount = 0;
    let totaldiscount = 0;
    let totalnet = 0;
    let invNetTotal = 0;
    let filerTaxAmt = 0;
    let saleTaxLov = this.state.saleTaxLov;
    let filerTax = this.state.filerTax;
    let netAmountSt = 0;
    let name = e?.target?.name;
    let currentValue = e?.target?.value?.toString().replaceAll(",", "");
    formValues[i]["amount"] = formValues[i]["amount"]
      .toString()
      .replaceAll(",", "");
    if ((currentValue < 0 || currentValue == "-") && name !== "discount") {
      if (name === "qty") {
        formValues[i]["qtyError"] = "Negative values not allowed";
      } else if (name === "rate") {
        formValues[i]["rateError"] = "Negative values not allowed";
      } else if (name === "amount") {
        formValues[i]["amountError"] = "Negative values not allowed";
        formValues[i]["rate"] = 0;
        formValues[i]["netAmount"] = 0;
      }

      formValues[i][e?.target?.name] = 0;
      this.setState({
        formValues,
      });
    } else {
      let targetValue = Number(e?.target?.value.toString().replaceAll(",", ""));

      // if (
      //   e.target.name === "discount" &&
      //   parseFloat(currentValue) > parseFloat(formValues[i]["amount"])
      // ) {
      //   formValues[i]["discount"] = 0;
      //   for (let index = 0; index < formValues.length; index++) {
      //     totaldiscount =
      //       parseFloat(totaldiscount) +
      //       parseFloat(formValues[index]["discount"]);
      //   }
      //   e.target.value = "";
      //   targetValue = 0;
      //   formValues[i]["netAmount"] = formValues[i]["amount"] - targetValue;
      //   formValues[i]["discountError"] = "Discount cannot be greater than amount";
      //   this.setState({
      //     formValues,
      //     totaldiscount,
      //   });
      //   thisContex.removeFormFieldsItem(i, true);
      // }
      //else if (e.target.name === "discount" && currentValue == "-") {
      //   formValues[i]["discountError"] = "Negative values not allowed";
      //   formValues[i]["discount"] = 0;
      //   targetValue = 0;
      // }

      formValues[i]["discountError"] = "";
      formValues[i][e?.target?.name] = e?.target?.value;
      formValues[i]["qty"] = formValues[i]["qty"]
        .toString()
        .replaceAll(",", "");
      formValues[i]["rate"] = formValues[i]["rate"]
        .toString()
        .replaceAll(",", "");
      formValues[i]["netAmount"] = formValues[i]["netAmount"]
        .toString()
        .replaceAll(",", "");
      formValues[i]["discount"] = formValues[i]["discount"]
        .toString()
        .replaceAll(",", "");
      formValues[i]["amount"] = formValues[i]["amount"]
        .toString()
        .replaceAll(",", "");

      if (e?.target?.name === "qty" && formValues[i]["amount"] > 0) {
        formValues[i]["amount"] = formValues[i]["rate"] * targetValue;
        // if (formValues[i]["rate"] > 0) {
        //   formValues[i]["rate"] = formValues[i]["rate"]?.toFixed(4);
        // }
      } else if (e?.target?.name === "amount" && formValues[i]["qty"]) {
        formValues[i]["rate"] = targetValue / formValues[i]["qty"];
        if (formValues[i]["rate"] > 0) {
          formValues[i]["rate"] = formValues[i]["rate"]?.toFixed(4);
        }
      } else if (e?.target?.name === "qty" && formValues[i]["rate"] > 0) {
        formValues[i]["amount"] = formValues[i]["rate"] * targetValue;
      } else if (e?.target?.name === "rate" && formValues[i]["qty"]) {
        formValues[i]["amount"] = formValues[i]["qty"] * targetValue;
      } else if (
        (e?.target?.name === "discount" &&
          formValues[i]["amount"] &&
          targetValue > 0) ||
        targetValue === 0
      ) {
        if (parseFloat(currentValue) > parseFloat(formValues[i]["amount"])) {
          targetValue = 0;
          formValues[i]["discount"] = 0;
          formValues[i]["discountError"] =
            "Discount cannot be greater than amount";
        } else if (targetValue === 0) {
          targetValue = 0;
          formValues[i]["discount"] = 0;
        } else {
        }
        formValues[i]["netAmount"] = formValues[i]["amount"] - targetValue;
      } else {
        if (e?.target?.value == "-" || e?.target?.value < 0) {
          targetValue = 0;
          formValues[i]["discount"] = 0;
        }

        formValues[i]["netAmount"] = formValues[i]["amount"] - targetValue;
      }

      if (formValues[i]["discount"]) {
        formValues[i]["netAmount"] =
          formValues[i]["amount"] - formValues[i]["discount"];
      }
      for (let index = 0; index < saleTaxLov.length; index++) {
        if (formValues[i]["saleTax"] == saleTaxLov[index]["STAX_GROUP_ID"]) {
          if (formValues[i]["netAmount"]) {
            netAmountSt =
              (parseFloat(formValues[i]["netAmount"]) *
                parseFloat(saleTaxLov[index].STAX_RATE)) /
              100;
            formValues[i]["stVal"] = netAmountSt;
            formValues[i]["netAmount"] =
              parseFloat(formValues[i]["netAmount"]) + parseFloat(netAmountSt);
          }
        }
      }

      for (let index = 0; index < formValues.length; index++) {
        formValues[index]["qty"] = formValues[index]["qty"]
          .toString()
          .replaceAll(",", "");
        formValues[index]["amount"] = formValues[index]["amount"]
          .toString()
          .replaceAll(",", "");
        formValues[index]["discount"] = formValues[index]["discount"]
          .toString()
          .replaceAll(",", "");
        formValues[index]["netAmount"] = formValues[index]["netAmount"]
          .toString()
          .replaceAll(",", "");

        totalqty = parseFloat(totalqty) + parseFloat(formValues[index]["qty"]);
        totalamount =
          parseFloat(totalamount) + parseFloat(formValues[index]["amount"]);
        totaldiscount =
          parseFloat(totaldiscount) + parseFloat(formValues[index]["discount"]);
        totalnet =
          parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);
      }

      if (formValues[i]["netAmount"] < 0 && formValues[i]["netAmount"] !== "") {
        formValues[i]["qty"] = 0;
        formValues[i]["rate"] = 0;
        formValues[i]["amount"] = 0;
        formValues[i]["discount"] = 0;
        formValues[i]["netAmount"] = 0;
        formValues[i]["netAamountError"] =
          "May Be Discount is greater than Amount";
      } else {
        formValues[i]["netAamountError"] = "";
      }

      console.log("56565656565totalnet", totalnet);
      console.log("56565656565filerTax", filerTax);
      // ensure totalnet is number
      let discTotalAmount = totalamount - totaldiscount;

      let net = totalnet;
      console.log("net", net);
      console.log("discTotalAmount", discTotalAmount);
      // filerTax is percentage (e.g., 5 means 5%)
      let filerTaxAmt =
        (parseFloat(discTotalAmount) * parseFloat(filerTax)) / 100;

      console.log("filerTaxAmt", filerTaxAmt);
      invNetTotal = parseFloat(net) + parseFloat(filerTaxAmt);
      console.log("invNetTotal:", invNetTotal); // numeric value

      // if you want to format it with commas for display
      invNetTotal = invNetTotal
        ? invNetTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : 0;

      totalnet = totalnet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totalqty = totalqty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totalamount = totalamount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totaldiscount = totaldiscount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totalnet = totalnet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totalqty = totalqty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totalamount = totalamount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      totaldiscount = totaldiscount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let sumSaleTaxVal = 0;
      for (let i = 0; i < formValues.length; i++) {
        sumSaleTaxVal += +formValues[i]["stVal"];
      }
      console.log("sumSaleTaxVal", sumSaleTaxVal);
      formValues[i]["qtyError"] = "";
      formValues[i]["rateError"] = "";
      formValues[i]["amountError"] = "";
      this.setState({
        formValues,
        totalqty,
        totalamount,
        totaldiscount,
        totalnet,
        invNetTotal,
        filerTaxAmt,
        sumSaleTaxVal: sumSaleTaxVal,
      });
    }
  }
  handleChangeItemLovs(i, e) {
    let formValues = this.state.formValues;
    let totalnet = 0;
    let invNetTotal = 0;
    let saleTaxLov = this.state.saleTaxLov;
    let filerTax = this.state.filerTax;
    let netAmountSt = 0;
    // let itemLov = this.state.itemLov;
    console.log("e.target.value :>> ", e);
    // console.log('formValues[i][e.target.name] :>> ', formValues[i][e.target.name]);
    // let itemObj = {
    //   ITEM_ID: e?.ITEM_ID,
    //   label: e?.label,
    // };
    // console.log("itemObj :>> ", itemObj);
    // formValues[i]["item_id"] = itemObj;
    // // formValues[i][e.target.name] = e.target.value;
    // console.log(" formValues[i][item_id] :>> ", formValues[i]["item_id"]);

    formValues[i]["netAmount"] = formValues[i]["netAmount"]
      .toString()
      .replaceAll(",", "");
    // let sum = 0;
    formValues[i]["saleTax"] = e.target.value;
    if (e.target.name === "saleTax") {
      // var index = e.nativeEvent.target.selectedIndex;
      // var saleTaxValue = e.nativeEvent.target[index].text;
      for (let index = 0; index < saleTaxLov.length; index++) {
        if (formValues[i]["saleTax"] == saleTaxLov[index]?.STAX_GROUP_ID) {
          console.log("discunt???>>>",formValues[i]["discount"])
          if (Number(formValues[i]["discount"])) {
            formValues[i]["netAmount"] =
              parseFloat(formValues[i]["amount"]) -
              parseFloat(formValues[i]["discount"]);
              console.log("check me >>",parseFloat(formValues[i]["amount"]) ,"-",
              parseFloat(formValues[i]["discount"]), " ===", formValues[i]["netAmount"])
          }
          console.log("netAmount???>>>11",formValues[i]["netAmount"])
          if (Number(formValues[i]["netAmount"])) {
            //   'formValues[i]["netAmount"] = ' +
            //     formValues[i]["netAmount"] +
            //     " ,saleTaxLov[index]?.STAX_GROUP_ID = " +
            //     saleTaxLov[index]?.STAX_GROUP_ID
            // );
            netAmountSt =
              (parseFloat(formValues[i]["amount"]) *
                parseFloat(saleTaxLov[index]?.STAX_RATE)) /
              100;

            formValues[i]["stVal"] = netAmountSt;
            formValues[i]["netAmount"] =
              parseFloat(formValues[i]["amount"]) + parseFloat(netAmountSt);
            formValues[i]["saleTaxID"] = saleTaxLov[index]?.STAX_GROUP_ID;
          console.log("netAmount???>>>22",formValues[i]["netAmount"])
          }
        }
      }
    }

    let sumSaleTaxVal = 0;
    for (let i = 0; i < formValues.length; i++) {
      sumSaleTaxVal += +formValues[i]["stVal"];
      totalnet += +parseFloat(formValues[i]["netAmount"]);
    }
    formValues[i]["netAmount"] = formValues[i]["netAmount"]
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          console.log("netAmount???>>>33",formValues[i]["netAmount"])
    let net = Number(totalnet);
    let discTotalAmount =
      parseFloat(formValues[i]["amount"]) -
      parseFloat(formValues[i]["discount"]);
    console.log("net", net);
    console.log("discTotalAmount", discTotalAmount);
    // filerTax is percentage (e.g., 5 means 5%)
    let filerTaxAmt = (discTotalAmount * filerTax) / 100;

    console.log("filerTaxAmt", filerTaxAmt);
    invNetTotal = net + filerTaxAmt;
    console.log("invNetTotal:", invNetTotal); // numeric value

    // if you want to format it with commas for display
    invNetTotal = invNetTotal
      .toFixed(2) // keep 2 decimals
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // totalnet = totalnet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.setState({
      formValues,
      totalnet,
      invNetTotal,
      filerTaxAmt,
      sumSaleTaxVal: sumSaleTaxVal,
    });
  }
  handleChangeItemLovsItem(i, e) {
    let formValues = this.state.formValues;
    let totalnet = 0;
    let saleTaxLov = this.state.saleTaxLov;
    let netAmountSt = 0;
    let itemLov = this.state.itemLov;
    // console.log('e.target.value :>> ', e);
    // console.log('formValues[i][e.target.name] :>> ', formValues[i][e.target.name]);
    //  let itemObj = {
    //     ITEM_ID: e?.ITEM_ID, label: e?.label
    //   }
    //   console.log('itemObj :>> ', itemObj);
    //   formValues[i]['item_id'] = itemObj
    // formValues[i][e.target.name] = e.target.value;
    // console.log(' formValues[i][item_id] :>> ',  formValues[i]['item_id']);

    formValues[i]["netAmount"] = formValues[i]["netAmount"]
      .toString()
      .replaceAll(",", "");
    // let sum = 0;
    // if (e.target.name === "item_id") {
    // console.log(e.target.value);
    // return
    // let itemIndex = e.item_id

    formValues[i]["itemCode"] = e?.ITEM_CODE;
    formValues[i]["item_id"] = e;
    // formValues[i]["itemTypeId"] = this.state.itemLov[itemIndex]?.ITEM_TYPE_ID;
    formValues[i]["uom_id"] = e?.UOM_ID;

    if (e?.ItemRateShow == "1") {
      formValues[i]["rate"] = e?.ItemRate ? e?.ItemRate : 0;
      formValues[i]["amount"] = formValues[i]["rate"] * formValues[i]["qty"];
      formValues[i]["netAmount"] =
        formValues[i]["amount"] - formValues[i]["discount"];

      // formValues[i]["netAmount"] =
      //   parseFloat(formValues[i]["netAmount"]) +
      //   parseFloat(formValues[i]["stVal"]);

      for (let index = 0; index < saleTaxLov.length; index++) {
        if (formValues[i]["saleTax"] == saleTaxLov[index]?.STAX_GROUP_ID) {
          if (formValues[i]["netAmount"]) {
            netAmountSt =
              (parseFloat(formValues[i]["netAmount"]) *
                parseFloat(saleTaxLov[index]?.STAX_RATE)) /
              100;

            formValues[i]["stVal"] = netAmountSt;
            formValues[i]["netAmount"] =
              parseFloat(formValues[i]["netAmount"]) + parseFloat(netAmountSt);
            formValues[i]["saleTaxID"] = saleTaxLov[index]?.STAX_GROUP_ID;
          }
        }
      }
    }

    // }

    let sumSaleTaxVal = 0;
    for (let i = 0; i < formValues.length; i++) {
      sumSaleTaxVal += +formValues[i]["stVal"];
      totalnet += +parseFloat(formValues[i]["netAmount"]);
    }
    formValues[i]["netAmount"] = formValues[i]["netAmount"]
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // totalnet = totalnet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.setState({ formValues, totalnet, sumSaleTaxVal: sumSaleTaxVal });
  }

  addFormFieldsItem() {
    let lineNumber = this.state.formValues.length + 1;
    this.setState({
      formValues: [
        ...this.state.formValues,
        {
          item_id: "",
          saleTax: 0,
          qty: 0,
          rate: 0,
          amount: 0,
          discount: 0,
          netAmount: 0,
          millNo: 1,
          desc: "",
          lineNum: lineNumber,
          stVal: 0,
          saleTaxID: "",
        },
      ],
      show: false,
    });
  }

  removeFormFieldsItem(i, refresh) {
    let formValues = this.state.formValues;

    if (formValues.length > 1 || refresh) {
      let totalqty = 0;
      let totalamount = 0;
      let totaldiscount = 0;
      let totalnet = 0;
      let sumSaleTaxVal = 0;
      // let pushDeleteArray = this.state.pushDeleteArray;

      // pushDeleteArray.push({
      //   itemId: formValues[i]["item_id"],
      //   itemCode: formValues[i]["itemCode"],
      //   qty: formValues[i]["qty"],
      // });
      if (!refresh) {
        formValues.splice(i, 1);
      }

      for (let index = 0; index < formValues.length; index++) {
        totalqty = parseFloat(totalqty) + parseFloat(formValues[index]["qty"]);
        totalamount =
          parseFloat(totalamount) + parseFloat(formValues[index]["amount"]);
        totaldiscount =
          parseFloat(totaldiscount) + parseFloat(formValues[index]["discount"]);
        totalnet =
          parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);
        formValues[index]["lineNum"] = index + 1;
      }
      for (let i = 0; i < formValues.length; i++) {
        sumSaleTaxVal += +formValues[i]["stVal"];
      }
      this.setState({
        formValues,
        totalqty,
        totalamount,
        totaldiscount,
        totalnet,

        sumSaleTaxVal: sumSaleTaxVal,
      });
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
    }
  }

  ////////////////////////////-----END------////////////////////////////////

  async componentDidMount() {
    await this.checkBussinessPermission();
    console.log("this.props", this.props);
    let buttonID = this.props.location?.rowData
      ? this.props.location?.rowData?.referencePk
      : this.props.location.state?.id;
    let goBackUrl = this.props.location?.goBackUrl;
    let goBackStates = this.props.location?.state?.goBackStates;
    let reportMsg =
      goBackStates && Object.keys(goBackStates).length > 0
        ? "Back to Report"
        : "Back to Overview";
    this.setState({
      goBackUrl,
      reportMsg,
      goBackStates,
    });
    this.getLovsLoad();
    getUserIp();
  }

  async checkBussinessPermission() {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission);
    let {
      business_type_id,
      isCrumble,
      isAgh,
      isDollarjnction,
      isNayyer,
      isEgcpl,
      isAlqadir,
    } = checkBussinessPermission;
    // if (isDollarjnction) {
    const fbr_inv_check = false; //isNayyer 
    thisContex.setState({
      isNayyer,
      isEgcpl,
      isAlqadir,
      fbr_inv_check : fbr_inv_check
    });
    // }
  }
  asyncRollCheck = async (value) => {
    let pathname = "/CreativeInvoice";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  async getItemLov(invType) {
    let itemTypeId =
      invType?.label === "Yarn"
        ? 13
        : invType?.label === "Raw Material"
        ? 14
        : invType?.label === "Fabric"
        ? 15
        : invType?.label === "Waste"
        ? 16
        : invType?.label === "Other"
        ? 17
        : null;

    thisContex.setState({ loadingResponce: true });
    axios
      .post(
        `${baseurl}/lovs/getItem`,
        { companyId: companyId, username: username, catId: itemTypeId },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        thisContex.setState({
          itemLov: response.data.data,
          loadingResponce: false,
          isLoadedlovItem: true,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  async getLovsLoad() {
    let buttonID = this.props.location?.rowData
      ? this.props.location?.rowData?.referencePk
      : this.props.location.state?.id;

    let idJ = this.props.location.state?.idJ;

    let idCustomer = -1;
    let hideHasBeen = false;

    if (buttonID || idJ) {
      if (
        this.props.location.state?.updateCheck === 2 ||
        idJ ||
        this.props.location?.rowData?.referencePk
      ) {
        await this.asyncRollCheck(0);
        thisContex.setState({
          disabled: true,
          showPrintButton: true,
        });
        this.setState({ show: true });
      } else {
        await this.asyncRollCheck(2);
        thisContex.setState({
          disabled: "",
          showPrintButton: false,
        });
      }
      if (this.props.location.state?.updateCheck !== 2) {
        hideHasBeen = true;
      }
      thisContex.setState({ loadingResponce: true });

      axios
        .post(
          `${baseurl}/masterData/getInvoiceDataWithId`,

          {
            id: buttonID,
            idJ,
            alqadirCheck: companyName === "Al_Qadir" ? true : false,
            username: username,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          let item_id, itemDesc;
          let itemCode;
          let uom_id;
          let saleTax;
          let qty;
          let amount;
          let discount;
          let desc;
          let netAmount;
          let rate;
          let totalqty = 0;
          let totalamount = 0;
          let totaldiscount = 0;
          let totalnet = 0;
          let invNetTotal = 0;
          let documentNo = -1;
          let journalId = -1;
          var res_mt = response.data.data[0];
          let alQadirDlvryDet = [];
          alQadirDlvryDet = response.data?.alQadirDlvryDet[0];
          var res_dt = response.data.data1;
          let customerName = "";
          let formData = [],
            itemObj;
          let conv_Rate = res_mt["CONV_RATE"];
          let customerEmail = res_mt["customerEmail"];
          let filerTaxAmt = res_mt["FC_ADJUSTED_AMOUNT"];
          let filerTax = res_mt["itax_filer_rate"];
          let builtyno = res_mt["builtyNo"];
          let code_nic = res_mt["code_nic"];
          let fbr_inv_id = res_mt["fbr_inv_id"]; 
          let builtyDate = null;
          let agentCode = "";
          let agentName = "";
          let agentContract = "";
          let agentRTNo = "";
          let agentTruckNo = "";
          let millNo = "";
          if (alQadirDlvryDet) {
            agentCode = alQadirDlvryDet["agent_code"]
              ? alQadirDlvryDet["agent_code"]
              : "";
            agentName = alQadirDlvryDet["agent_name"]
              ? alQadirDlvryDet["agent_name"]
              : "";
            agentContract = alQadirDlvryDet["agent_contract"]
              ? alQadirDlvryDet["agent_contract"]
              : "";
            agentRTNo = alQadirDlvryDet["agent_rt_num"]
              ? alQadirDlvryDet["agent_rt_num"]
              : "";
            agentTruckNo = alQadirDlvryDet["agent_truck_num"]
              ? alQadirDlvryDet["agent_truck_num"]
              : "";
          }
          if (
            res_mt["builtyDate"] &&
            res_mt["builtyDate"] !== "0000-00-00 00:00:00"
          ) {
            builtyDate = new Date(res_mt["builtyDate"]);
            if (isNaN(builtyDate)) {
              builtyDate = null; // Handle if the date is still invalid after parsing
            }
          }
          documentNo = res_mt["DOCUMENT_NO"];
          let formValues2;
          let sumSaleTaxVal = 0;
          let stVal = 0;
          let saleTaxRate = 0;
          let staxTcAmount = 0;

          formData.pop();
          console.log("res_dt :>> ", res_dt);
          for (let index = 0; index < res_dt.length; index++) {
            // item_id = res_dt[index]["ITEM_ID"];
            item_id = res_dt[index]["detail_item_id"];
            // itemCode = res_dt[index]["ITEM_CODE"];
            itemCode = res_dt[index]["detail_item_code"];
            // itemDesc = res_dt[index]["ITEM_DESC"];
            itemDesc = res_dt[index]["detail_item_desc"];
            itemDesc = res_dt[index]["detail_item_desc"];
            uom_id = res_dt[index]["UOM_ID"];
            saleTax = res_dt[index]["STAX_GROUP_ID"];
            qty = res_dt[index]["PRIMARY_QTY"];
            discount = res_dt[index]["TC_DISCOUNT"];
            amount = res_dt[index]["TC_AMOUNT"];
            stVal = res_dt[index]["STAX_AMOUNT"] / conv_Rate;
            saleTaxRate = res_dt[index]["STAX_RATE"];
            staxTcAmount = res_dt[index]["STAX_TC_AMOUNT"];
            // desc = res_dt[index]["ITEM_DESC"];
            desc = res_dt[index]["detail_item_desc"];
            millNo = res_dt[index]["mill_no"];

            rate = amount / qty;
            netAmount = ((amount - discount) * saleTaxRate) / 100;
            netAmount = netAmount + (amount - discount);

            itemObj = {
              id: item_id,
              label: itemDesc,
              itemCode: itemCode,
              uomId: uom_id,
            };
            formData.push({
              item_id: itemObj,
              itemCode: itemCode,
              saleTax: saleTax,
              qty: qty,
              amount: amount,
              discount: discount,
              // desc: desc,
              millNo: millNo,
              netAmount: netAmount,
              rate: rate,
              stVal: stVal,
              staxTcAmount: staxTcAmount,
              INVOICE_DET_ID: res_dt[index]["INVOICE_DET_ID"],
              lineNum: index + 1,
              uom_id: uom_id,
            });
          }
          for (let index = 0; index < formData.length; index++) {
            totalqty =
              parseFloat(totalqty) + parseFloat(formData[index]["qty"]);
            totalamount =
              parseFloat(totalamount) + parseFloat(formData[index]["amount"]);
            totaldiscount =
              parseFloat(totaldiscount) +
              parseFloat(formData[index]["discount"]);
            totalnet =
              parseFloat(totalnet) + parseFloat(formData[index]["netAmount"]);
            sumSaleTaxVal =
              parseFloat(sumSaleTaxVal) +
              parseFloat(formData[index]["staxTcAmount"]);
          }
          invNetTotal = parseFloat(totalnet) + parseFloat(filerTaxAmt);

          let invoiceDate = new Date(res_mt["INVOICE_DATE"]);
          let dueDate = new Date(res_mt["DUE_DATE"]);
          formValues2 = formData;

          idCustomer = res_mt["CUSTOMER_ID"];
          journalId = res_mt["JOURNAL_ID"];
          customerName = res_mt["customerName"];

          let bankObj = {};
          if (res_mt["BANK_ACC_ID"]) {
            bankObj = { id: res_mt["BANK_ACC_ID"], label: res_mt["label"] };
          }
          let objBranch = {};
          if (res_mt["sub_inv_id"]) {
            objBranch = {
              id: res_mt["sub_inv_id"],
              label: res_mt["sub_inv_desc"],
              value: res_mt["sub_inv_id"],
            };
          }
          let objCarrier = null;
          if (res_mt["carreir_id"]) {
            objCarrier = {
              id: res_mt["carreir_id"],
              label: res_mt["carreir_desc"],
              value: res_mt["carreir_id"],
            };
          }
          let objfilerYn = null;
          if (res_mt["itax_filer_id"]) {
            objfilerYn = {
              id: res_mt["itax_filer_id"],
              label: res_mt["itax_filer_desc"],
              value: res_mt["itax_filer_rate"],
            };
          }
          console.log("formData :>> ", formData);
          thisContex.setState({
            invoiceNumber: res_mt["DOCUMENT_NO"],
            inv_book_id: res_mt["INV_BOOK_ID"],
            invoice_date: invoiceDate,
            after_date: dueDate,
            invoice_ref_no: res_mt["INVOICE_REF_NO"],
            pONumber: res_mt["PO_NUMBER"],
            payment_term_id: res_mt["PAYMENT_TERM_ID"],
            currency_Id: res_mt["CURRENCY_ID"],
            curDesc: res_mt["CURRENCY_SYMBOL"],
            conv_Rate: res_mt["CONV_RATE"],
            builtyno: builtyno,
            code_nic: code_nic,
            fbr_inv_id: fbr_inv_id,
            agentCode: agentCode,
            agentName: agentName,
            agentContract: agentContract,
            agentRTNo: agentRTNo,
            agentTruckNo: agentTruckNo,
            builtyDate: builtyDate,
            career: objCarrier,
            filerYn: objfilerYn,
            byIdBranchLovVal: objBranch,
            dynamicLovVal: objBranch,
            customerName: customerName,
            remarks: res_mt["REMARKS"] ? res_mt["REMARKS"] : "",
            paid: 0,
            formValues: formData,
            totalqty,
            totalamount,
            invNetTotal: invNetTotal,
            filerTaxAmt: filerTaxAmt,
            filerTax: filerTax,
            totaldiscount,
            totalnet,
            sumSaleTaxVal,
            documentNo: documentNo,
            postYn: res_mt["posted_yn"],
            customerEmail: customerEmail,
            beenPaid: res_mt["BEEN_PAID"] ? "1" : "0",
            journalId,
            cat_id: bankObj,
            loadingResponce: false,
            hideHasBeen,
          });
          thisContex.setState({ loadingResponce: true });

          axios
            .post(
              `${baseurl}/lovs/getClient`,
              { companyId: companyId, username: username },
              {
                headers: {
                  authorization: token,
                },
              }
            )
            .then(function (response) {
              let mydata = [];
              let customerEmail = [];
              let newLabel = "";
              let responseData = response.data.data;
              for (let loop = 0; loop < responseData.length; loop++) {
                mydata.push({
                  id: responseData[loop]["CUSTOMER_ID"],
                  label: responseData[loop]["COMPANY_NAME"],
                  email: responseData[loop]["CUSTOMER_EMAIL"],
                  CUSTOMER_CODE: responseData[loop]["CUSTOMER_CODE"],
                  cnic: responseData[loop]["cnic"],
                });
                if (responseData[loop]["CUSTOMER_ID"] === idCustomer) {
                  newLabel = responseData[loop]["COMPANY_NAME"];
                  customerEmail = responseData[loop]["CUSTOMER_EMAIL"];
                }
              }
              let objCustomer = {
                id: idCustomer,
                label: newLabel,
                email: customerEmail,
              };
              thisContex.setState({
                loadingResponce: false,
                clientLov: mydata,
                customer_id: objCustomer,
              });
            })
            .catch(function (error) {
              console.log(error);
            });
          axios
            .post(
              `${baseurl}/lovs/getCarrier`,
              { companyId: companyId, username: username },
              {
                headers: {
                  authorization: token,
                },
              }
            )
            .then(function (response) {
              let responseData = response.data.data;
              thisContex.setState({
                loadingResponce: false,
                careerLov: responseData,
              });
            })
            .catch(function (error) {
              console.log(error);
            });
          axios
            .post(
              `${baseurl}/lovs/getFilerLov`,
              { companyId: companyId, username: username },
              {
                headers: {
                  authorization: token,
                },
              }
            )
            .then(function (response) {
              let responseData = response.data.data;
              thisContex.setState({
                loadingResponce: false,
                filerLov: responseData,
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log(error);
        });
      // if (buttonID) {
      // } else {
      thisContex.setState({ loadingResponce: true });
      axios
        .post(
          // `${baseurl}/lovs/getProductionCenterDetLov`,
          `${baseurl}/lovs/getGlPreferences`,

          { companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          // let mydata = [];
          let responseData = response.data.data[0];
          if (
            responseData.multi_branch_yn === 1 ||
            responseData.multi_branch_yn === "1"
          ) {
            thisContex.setState({
              // itemLov: response.data.data,
              labelBranchLov: responseData?.sub_inv_name,
              showBranchLov: true,
              loadingResponce: false,
            });
          } else {
            thisContex.setState({
              // itemLov: response.data.data,
              defaultLovVal: responseData?.def_sub_inv_id,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      // }

      axios
        .post(
          `${baseurl}/lovs/getPaymentTerms`,
          { username: username, companyId },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          thisContex.setState({
            paymentsTermsLov: response.data.data,
            loadingResponce: false,
            isLoadedlovPaymentsTerms: true,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      thisContex.setState({ loadingResponce: true });

      axios
        .post(
          `${baseurl}/lovs/getCurrency`,
          { username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          thisContex.setState({
            currencyLov: response.data.data,
            loadingResponce: false,
            isLoadedlovCurrency: true,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      thisContex.setState({ loadingResponce: true });

      axios
        .post(
          `${baseurl}/lovs/getItem`,

          { companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          thisContex.setState({
            itemLov: response.data.data,
            loadingResponce: false,

            isLoadedlovItem: true,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      thisContex.setState({ loadingResponce: true });

      axios
        .post(
          `${baseurl}/taxSale/getSaleTaxMainData`,
          { companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          let isLoad = false;
          if (response.data.data.length > 0) {
            isLoad = true;
          }
          thisContex.setState({
            saleTaxLov: response.data.data,
            loadingResponce: false,
            isLoadedlovSaleTax: isLoad,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      thisContex.setState({ loadingResponce: true });

      axios
        .post(
          `${baseurl}/taxSale/getSaleTaxMainData`,
          { companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          let mydata = [];
          let responseData = response.data.data;

          for (let loop = 0; loop < responseData.length; loop++) {
            mydata.push({
              id: responseData[loop]["STAX_GROUP_ID"],
              label: `${responseData[loop]["STAX_RATE"]}%`,
            });
          }
          thisContex.setState({
            loadingResponce: false,
            defaultSalesTaxOptions: mydata,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      thisContex.setState({ loadingResponce: true });
      axios
        .post(
          `${baseurl}/lovs/getBankCash`,
          { companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          thisContex.setState({
            loadingResponce: false,
            bankCash: response.data.data,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      await this.asyncRollCheck(1);
      const permission = this.state.permission;
      if (permission) {
        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            `${baseurl}/lovs/getBankCash`,
            { companyId: companyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            thisContex.setState({
              loadingResponce: false,
              bankCash: response.data.data,
            });
          })
          .catch(function (error) {
            console.log(error);
          });

        this.checkDateOfYear("did");
        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            // `${baseurl}/lovs/getProductionCenterDetLov`,
            `${baseurl}/lovs/getGlPreferences`,

            { companyId: companyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            // let mydata = [];
            let responseData = response.data.data[0];
            if (
              responseData.multi_branch_yn === 1 ||
              responseData.multi_branch_yn === "1"
            ) {
              thisContex.setState({
                // itemLov: response.data.data,
                labelBranchLov: responseData?.sub_inv_name,
                showBranchLov: true,
                loadingResponce: false,
              });
            } else {
              thisContex.setState({
                // itemLov: response.data.data,
                defaultLovVal: responseData?.def_sub_inv_id,
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        axios
          .post(
            `${baseurl}/lovs/getPaymentTerms`,
            { username: username, companyId },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            thisContex.setState({
              loadingResponce: false,
              paymentsTermsLov: response.data.data,
              isLoadedlovPaymentsTerms: true,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            `${baseurl}/lovs/getCurrency`,
            { username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            thisContex.setState({
              currencyLov: response.data.data,
              loadingResponce: false,
              isLoadedlovCurrency: true,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            `${baseurl}/masterData/getCompanyCurrWithId`,
            { id: currencyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            let data = response.data.data;
            data = data[0].CURRENCY_SYMBOL;
            thisContex.setState({
              loadingResponce: false,
              curDesc: data,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            `${baseurl}/lovs/getItem`,
            { companyId: companyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            thisContex.setState({
              itemLov: response.data.data,
              loadingResponce: false,
              isLoadedlovItem: true,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            `${baseurl}/taxSale/getSaleTaxMainData`,
            { companyId: companyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            let isLoad = false;
            if (response.data.data.length > 0) {
              isLoad = true;
            }
            thisContex.setState({
              saleTaxLov: response.data.data,
              loadingResponce: false,
              isLoadedlovSaleTax: isLoad,
            });
          })
          .catch(function (error) {
            console.log(error);
          });

        this.refreshData();

        thisContex.setState({ loadingResponce: true });
        axios
          .post(
            `${baseurl}/taxSale/getSaleTaxMainData`,
            { companyId: companyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            let mydata = [];
            let responseData = response.data.data;

            for (let loop = 0; loop < responseData.length; loop++) {
              mydata.push({
                id: responseData[loop]["STAX_GROUP_ID"],
                label: `${responseData[loop]["STAX_RATE"]}%`,
              });
            }
            thisContex.setState({
              loadingResponce: false,
              defaultSalesTaxOptions: mydata,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
  getBanks = () => {
    axios
      .post(
        `${baseurl}/lovs/getBankCash`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        thisContex.setState({
          bankCash: response.data.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  checkDateOfYear = async (e) => {
    var invoiceDate;
    let byDefault;
    if (e === "did") {
      byDefault = "didMount";
      invoiceDate = thisContex.state.invoice_date;
    } else {
      byDefault = "";
      invoiceDate = e;
    }

    const tableName = "invoice_mt";
    const invoiceType = 1;
    const invBookId = 1;
    const dateColumn = "INVOICE_DATE";
    const documentNo = "DOCUMENT_NO";
    var date = moment(invoiceDate).format("YYYY-MM-DD");

    let closeDate = await CheckClosingYearD(
      date,
      tableName,
      invoiceType,
      invBookId,
      dateColumn,
      documentNo,
      byDefault
    );
    var docNo = closeDate[1];

    if (closeDate[0] === true) {
      thisContex.setState({
        invoice_date: "",
        invoiceNumber: "",
      });
    } else if (closeDate[0] === false) {
      thisContex.setState({
        invoice_date: invoiceDate,
        invoiceNumber: docNo,
      });
    } else {
      thisContex.setState({
        invoice_date: "",
        invoiggceNumber: "",
      });
    }
  };
  toggleAddNew = (e) => {
    this.setState({
      showModalAddNew: !this.state.showModalAddNew,
    });
  };
  handleLanguage = (lng) => {
    console.log(lng[0]);
    console.log(lng[1]);

    this.setState({
      formName: lng[0],
      backToOverView: lng[1],
      client: lng[2],
      IssueDate: lng[3],
      Invoice: lng[4],
      poNo: lng[5],
      refference: lng[6],
      CurrencyName: lng[7],
      note: lng[8],
      beenPaidText: lng[9],
      paymentTerms: lng[10],
      itemName: lng[11],
      qtyName: lng[12],
      rateName: lng[13],
      amountName: lng[14],
      discountName: lng[15],
      netAmountName: lng[16],
      descriptionName: lng[17],
      saleTaxName: lng[18],
    });
  };
  toggleAddNewItem = () => {
    this.setState({ showModalAddNewItem: !this.state.showModalAddNewItem });
  };
  toggleOpen = () => {
    this.setState({ showModalOpen: !this.state.showModalOpen });
  };
  addToggle = () => {
    this.setState({
      showModalAddNew: !this.state.showModalAddNew,
    });
    // this.refreshData();
  };
  addToggleSubmit = () => {
    this.setState({});
    this.toggleAddNew();
  };

  addToggleItem = () => {
    this.setState({});
    this.toggleAddNewItem();
  };
  dynamicBranchSelect = (selectedObj) => {
    console.log("selectedObj", selectedObj);
    this.setState({
      dynamicLovVal: selectedObj,
    });
  };
  itemLoad = (e) => {
    this.setState({
      showItemForm: !this.state.showItemForm,
    });
    this.getLovsLoad();
  };

  handleKey = (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      this.quickSearchHandleChange(e);
    }
  };

  modelLinkButton = (masterIdParam) => {
    thisContex.setState({
      loadingResponce: true,
    });

    const endPoint = this.state.isNayyer
      ? "updateNayyerPostYNInvoice"
      : "updatePostYNInvoice";
    const {
      invoice_ref_no,
      pONumber,
      invoice_date,
      builtyno,
      builtyDate,
      career,
      filerYn,
      currency_Id,
      customer_id,
      formValues,
      jrArray,
      totalnet,
      filerTax,
      totaldiscount,
      totalamount,
      customerName,
      customerEmail,
      masterId,
      conv_Rate,
      documentNo,
      userIp,
      userCountry,
      dynamicLovVal,
      defaultLovVal,
      agentCode,
      agentName,
      agentContract,
      agentRTNo,
      agentTruckNo,
      filerTaxAmt,
    } = thisContex.state;
    let sumSaleTaxVal = 0;
    console.log("immm herer1");
    let formValues2 = formValues;
    for (let i = 0; i < formValues.length; i++) {
      sumSaleTaxVal += +formValues2[i]["stVal"];
      formValues2[i]["netAmount"] = formValues2[i]["netAmount"]
        .toString()
        .replaceAll(",", "");
    }
    var randomCode = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < 5; i++) {
      randomCode += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    let date = moment(invoice_date).format("YYYY-MM-DD");
    // return
    console.log("immm herer2");

    axios
      .post(
        `${baseurl}/masterData/${endPoint}`,
        {
          id: masterId || masterIdParam,
          companyId: companyId,
          invoice_ref_no: invoice_ref_no,
          pONumber: pONumber,
          saleTaxID: formValues[0]["saleTaxID"],
          filerTaxAmt: filerTaxAmt.toString().replaceAll(",", "") ?? 0,
          invoice_date: date,
          currency_Id: currency_Id,
          customer_id: customer_id.id,
          customerName: customerName,
          customerEmail: customerEmail,
          randomCode: randomCode,
          arr_jrn_det: jrArray,
          conv_Rate: conv_Rate,
          sumSaleTaxVal: sumSaleTaxVal,
          totalnet: totalnet.toString().replaceAll(",", ""),
          totalAmountIncAll: totalnet.toString().replaceAll(",", ""),
          totaldiscount: totaldiscount.toString().replaceAll(",", ""),
          totalamount: totalamount.toString().replaceAll(",", ""),
          documentNo: documentNo,
          username: username,
          userIp,
          userCountry,
          branchLov: dynamicLovVal.id || defaultLovVal,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let resMessage = res.data.message;
        // alert
        let resDate = res.data.resDate;
        let itemCode = res.data.itemCode;
        console.log("immm herer3");

        if (resMessage == "Negavtive Item") {
          swal({
            title: `Item of code ${itemCode} is being negetive on ${resDate}`,
            text: "issue",
            icon: "error",
          });
          thisContex.setState({
            loadingResponce: false,
          });
          if (companyName === "Al_Qadir") {
          } else {
            thisContex.toggle();
          }
        } else {
          console.log("immm herer4");

          var latestDocNo = res.data.inv_doc_no;
          thisContex.setState({
            loadingResponce: false,
            invoiceNumber: latestDocNo,
          });
          // this.setState({});
          if (companyName === "Al_Qadir") {
          } else {
            thisContex.toggle();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  toggle = (e) => {
    this.setState({ showModal: !this.state.showModal });
  };

  refreshData = () => {
    axios
      .post(
        `${baseurl}/lovs/getClient`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydata = [];
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["CUSTOMER_ID"],
            label:
              companyName === "Al_Qadir" || companyName === "AA_Cotton"
                ? responseData[loop]["ntax_No"] +
                  " | " +
                  responseData[loop]["COMPANY_NAME"]
                : responseData[loop]["COMPANY_NAME"],
            email: responseData[loop]["CUSTOMER_EMAIL"],
            CUSTOMER_CODE: responseData[loop]["CUSTOMER_CODE"],
            cnic: responseData[loop]["cnic"],
          });
        }
        thisContex.setState({
          clientLov: mydata,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .post(
        `${baseurl}/lovs/getCarrier`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let responseData = response.data.data;

        thisContex.setState({
          loadingResponce: false,
          careerLov: responseData,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .post(
        `${baseurl}/lovs/getFilerLov`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let responseData = response.data.data;
        thisContex.setState({
          loadingResponce: false,
          filerLov: responseData,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  render() {
    const {
      copyInvperm,
      amountError,
      discountError,
      rateError,
      qtyError,
      isLoadedlovPaymentsTerms,
      clientLov,
      code_nic,
      isLoadedlovCurrency,
      isLoadedlovItem,
      itemLov,
      saleTaxLov,
      isLoadedlovSaleTax,
      currencyLov,
      paymentsTermsLov,
      remarks,
      beenPaid,
      addBankToggle,
      totalqty,
      totalnet,
      invNetTotal,
      filerTax,
      filerTaxAmt,
      totaldiscount,
      totalamount,
      customer_id,
      invoice_date,
      builtyno,
      builtyDate,
      career,
      filerYn,
      invoice_ref_no,
      payment_term_id,
      currency_Id,
      isActive,
      invoiceNumber,
      cat_id,
      bankCash,
      pONumber,
      showPaymentHistory,
      // paid,
      sumSaleTaxVal,
      conv_Rate,
      current_currency_Id,
      RateError,
      QuantityError,
      ItemError,
      showModalAddNew,
      permission,
      showItemForm,
      paymentHistory,
      curDesc,
      hideHasBeen,
      catError,
      postYn,
      inv_book_id,
      goBackUrl,
      reportMsg,
      goBackStates,
      after_date,
      byIdBranchLovVal,
      showBranchLov,
      labelBranchLov,
      disabled,
      agentCode,
      agentName,
      agentContract,
      agentRTNo,
      agentTruckNo,
    } = this.state;
    const { location } = this.props;
    const { state } = location || {};
    const locationId = state?.id;
    const shouldShowBranchLov = locationId && byIdBranchLovVal && showBranchLov;

    // select = localStorage.getItem("select")
    if (this.state.logInStatus === false) {
      return <Redirect to="/login" />;
    }
    // else if (this.state.loadingResponce === true) {
    //   return <ResponseLoader />;
    // }
    else if (this.state.redirectToPrint) {
      return (
        <Redirect
          push
          to={{
            // pathname: "/PrintView",
            pathname: "/purchasePrintView",
            state: {
              companyId: this.state.companyId,
              id: this.state.invoiceId,
              url: this.props.location.pathname,
              updateCheck: this.props.location.state?.updateCheck,
              headerPrefix: this.state.headerPrefix,
            },
          }}
        />
      );
    } else if (this.state.emailPrefference) {
      return (
        <Redirect
          push
          to={{
            pathname: "/Actions",
            state: {
              propsActions: "EmailPreference",
              //propsPaymentMtId: this.state.rowPaymentMtId,
              // propCurrId: thisContex.state.currId,
              //propUnApplyAmt: thisContex.state.rowUnApplyAmnt,
              // propTotalAmount: thisContex.state.receiptTotalAmt,
              // propBankId: thisContex.state.receiptBankId,
              // propBankName: thisContex.state.receiptBankName,
              // propInvoiceId: thisContex.state.propInvoiceId,
            },
          }}
        />
      );
    }
    return (
      <div className="animated fadeIn">
        {/* <Abc onSelectLanguage={(p) => this.handleLanguage(p)} /> */}
        {this.state.loadingResponce && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        <Row className="Creative-Invoice-header-styling">
          <Col xs="6" className="card-header-Creative-Invoice">
            <>
              <strong>
                {/* <h4>{this.props.location.state?.updateCheck == 2  ? null : "Invoice" } {inv_book_id == 1 && postYn == 1 ? 'Invoice'}</h4> */}
                {/* <h4>{(this.props.location.state?.updateCheck != 0 ||this.props.location.state?.updateCheck != 2) ? "Create Invoice" : {(this.props.location.state?.updateCheck == 0 && postYn ==0 && inv_book_id == 1) ? "Update":null}}</h4> */}
                <h4>
                  {this.props.location.state?.updateCheck == 0 ? "Update " : ""}
                  {inv_book_id == 1
                    ? postYn == 1
                      ? "Invoice"
                      : "Invoice (Draft)"
                    : inv_book_id == 9
                    ? "Estimate"
                    : this.state.formName}
                </h4>
              </strong>
            </>
          </Col>
          <Col xs="6" className="card-header-Creative-Invoice">
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Link
                to={{
                  pathname: goBackUrl ? goBackUrl : "/OverviewInvoice",
                  goBackStates: goBackStates,
                }}
                title={tooltipText.backSaleOver}
                style={{
                  fontFamily: "Times New Roman",
                  fontWeight: "normal",
                  margin: "10px",
                }}
              >
                <u className="Back-to-Overview">{reportMsg}</u>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-chevron-left mx-2 icon-color"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
              </Link>
            </div>
          </Col>
        </Row>

        <div className="animated fadeIn">
          <Row className="rowStyling">
            <Col>
              <div className="row ">
                <div className="col-md-12">
                  <Form
                    onSubmit={handleSubmitAddNew}
                    name="addNewForm"
                    autocomplete="off"
                    onKeyPress={(event) => {
                      if (event.which === 13 /* Enter */) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <div className="m-1">
                      <div className="row ">
                        {this.props.location.state?.id &&
                        this.state.showBranchLov ? (
                          this.state.byIdBranchLovVal && (
                            <div
                              translate="no"
                              className="col-md-1 col-lg-1"
                              style={{ marginBottom: "10px" }}
                            >
                              <BranchDynamicLov
                                label={labelBranchLov}
                                value={byIdBranchLovVal}
                                callBack={(data) =>
                                  this.dynamicBranchSelect(data)
                                }
                                isRequired={showBranchLov}
                                isDisabled={!!disabled}
                              />
                            </div>
                          )
                        ) : this.state.showBranchLov ? (
                          <div
                            translate="no"
                            className="col-md-2 col-lg-2"
                            style={{ marginBottom: "10px" }}
                          >
                            <BranchDynamicLov
                              label={labelBranchLov}
                              value={byIdBranchLovVal}
                              callBack={(data) =>
                                this.dynamicBranchSelect(data)
                              }
                              isRequired={showBranchLov}
                              isDisabled={!!disabled}
                            />
                          </div>
                        ) : null}

                        <div translate="no" className="col-md-2 my-1">
                          {localStorage.getItem("lan") === "ur" ? (
                            <Label
                              translate="yes"
                              style={{ fontWeight: "bold" }}
                            >
                              {this.state.clientUrdu}{" "}
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                          ) : (
                            <Label
                              translate="yes"
                              style={{ fontWeight: "bold" }}
                            >
                              {this.state.client}{" "}
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                          )}
                          <Select
                            value={customer_id}
                            onChange={this.handleChangeLovsSelect}
                            options={clientLov}
                            autoFocus
                            isClearable
                            required
                            name="selectedOptionPhase"
                            placeholder={select}
                            isDisabled={this.state.disabled ? true : false}
                          />
                        </div>
                        <div translate="no" className="col-md-2 my-1">
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Code || CNIC
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <Input
                            type="text"
                            value={code_nic}
                            // onChange={this.handleChangeLovsSelect}
                            // options={clientLov}
                            // autoFocus
                            // isClearable
                            required
                            name="selectedOptionPhase"
                            // placeholder={select}
                            disabled
                          />
                        </div>

                        <div className="col-md-1 my-1 input-group d-flex flex-column">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.IssueDate}:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <div className=" d-flex flex-row">
                            <DatePicker
                              className="form-control "
                              wrapperClassName="datePicker"
                              id="invoice_date"
                              name="invoice_date"
                              placeholderText="dd-mm-yyyy"
                              disabled={this.state.disabled ? true : false}
                              selected={invoice_date}
                              dateFormat="dd-MM-yyyy"
                              required
                              onCalendarClose={() => {
                                this.onChangeDatePicker();
                              }}
                              onChange={(e) => {
                                if (this.state.beenPaid == "1") {
                                  thisContex.setState({ due_date: e });
                                }
                                thisContex.setState({ invoice_date: e });
                              }}
                            />
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="calended_icon">
                                <i
                                  class="fa fa-calendar-plus-o"
                                  aria-hidden="true"
                                />
                              </InputGroupText>
                            </InputGroupAddon>
                          </div>
                        </div>

                        <div className="col-md-1 my-1">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.Invoice}#:{" "}
                          </Label>
                          <Input
                            type="number"
                            id="invoiceNumber"
                            name="invoiceNumber"
                            className="form-control"
                            style={{ textAlign: "right" }}
                            placeholder=""
                            value={invoiceNumber}
                            onChange={this.handleChange}
                            disabled={true}
                            required
                          ></Input>
                        </div>

                        <div className="col-md-1 my-1">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.poNo}:
                          </Label>
                          <Input
                            type="number"
                            id="pONumber"
                            name="pONumber"
                            className="form-control"
                            style={{ textAlign: "right" }}
                            placeholder=""
                            value={pONumber}
                            disabled={this.state.disabled ? true : false}
                            onChange={this.handleChange}
                          ></Input>
                        </div>

                        <div className="col-md-1 my-1">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.refference}:
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            onChange={this.handleChange}
                            id="invoice_ref_no"
                            name="invoice_ref_no"
                            style={{ textAlign: "right" }}
                            disabled={this.state.disabled ? true : false}
                            placeholder=""
                            value={invoice_ref_no}
                            // required
                          />
                        </div>

                        <div translate="no" className="col-md-2 my-1">
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            {this.state.CurrencyName}:{" "}
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="input-tag-text">
                                {curDesc}
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              type="select"
                              id="currency_Id"
                              name="currency_Id"
                              className="form-control"
                              disabled={this.state.disabled ? true : false}
                              placeholder=""
                              value={currency_Id}
                              onChange={(e) => {
                                this.handleChangeLovs(e);
                              }}
                              required
                            >
                              <option value="" disabled>
                                -- Select --
                              </option>
                              {isLoadedlovCurrency
                                ? currencyLov.map((itm, index) => {
                                    return (
                                      <option
                                        key={index}
                                        value={itm.CURRENCY_ID}
                                      >
                                        {itm.CURRENCY_DESC}
                                      </option>
                                    );
                                  })
                                : ""}
                            </Input>
                          </InputGroup>
                        </div>

                        {current_currency_Id.toString() !==
                        currency_Id.toString() ? (
                          <div className="col-md-1 my-1">
                            <Label style={{ fontWeight: "bold" }}>Rate</Label>
                            <NumberFormat
                              name="conv_Rate"
                              style={{ textAlign: "right" }}
                              className="form-control"
                              thousandSeparator={true}
                              placeholder="0.0000"
                              decimalScale={4}
                              disabled={this.state.disabled ? true : false}
                              value={conv_Rate || ""}
                              onChange={this.handleChange}
                              // onBlur={(e) => {
                              //   this.checkDiscountVlidation(index, e);
                              // }}
                            />
                          </div>
                        ) : null}

                        <div className="col-md-2 my-1">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.note}:
                          </Label>
                          <Input
                            rows="1"
                            type="textarea"
                            id="remarks"
                            name="remarks"
                            className="form-control"
                            onKeyPress={(e) => {
                              this.newLinefunNotes(e);
                            }}
                            value={remarks || ""}
                            disabled={this.state.disabled ? true : false}
                            onChange={this.handleChange}
                          ></Input>
                        </div>

                        {hideHasBeen === false ? (
                          <div translate="no" className="col-md-1 my-1">
                            <Label
                              translate="yes"
                              style={{ fontWeight: "bold" }}
                            >
                              {this.state.beenPaidText}
                            </Label>
                            <Input
                              type="select"
                              id="beenPaid"
                              name="beenPaid"
                              className="form-control"
                              placeholder=""
                              disabled={this.state.disabled ? true : false}
                              value={beenPaid}
                              onChange={this.handleChange}
                              required
                            >
                              <option value="0" selected>
                                No
                              </option>
                              <option value="1">Yes</option>
                            </Input>
                          </div>
                        ) : null}
                        {beenPaid === "1" && (
                          <>
                            <div className="col-md-2 my-1">
                              <Label style={{ fontWeight: "bold" }}>
                                Which bank account were you paid into?
                                <h8 style={{ color: "tomato" }}>*</h8>
                              </Label>
                              <Select
                                value={cat_id}
                                onChange={this.handleChangeBankLovs}
                                options={bankCash}
                                name="cat_id"
                                isClearable
                                placeholder={"-- Select --"}
                                isDisabled={
                                  this.state.disabled ? "disabled" : ""
                                }
                                required
                              />
                              {catError ? (
                                <>
                                  <h7
                                    style={{
                                      color: "red",
                                      fontSize: "75%",
                                    }}
                                  >
                                    Bank is required!
                                  </h7>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-1 mt-4">
                              <Button
                                className="btn-client-invoice mt-2"
                                onClick={() =>
                                  thisContex.setState({ addBankToggle: true })
                                }
                              >
                                Add bank
                              </Button>
                            </div>
                          </>
                        )}
                        {addBankToggle && (
                          <>
                            <Modal
                              show={addBankToggle}
                              size="lg"
                              onHide={this.toggleAddBankModel}
                              backdrop="static"
                            >
                              <Modal.Body className="mt-n4 px-1 mb-n3">
                                <BankAdd
                                  closeModel={"closeModel"}
                                  callBack={() => {
                                    this.toggleAddBankModel();
                                    this.getBanks();
                                  }}
                                />
                              </Modal.Body>
                            </Modal>
                          </>
                        )}

                        <div className="col-md-2 my-1">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.paymentTerms}:{" "}
                          </Label>
                          <InputGroup className="mb-4">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="input-tag-text">
                                <i>Days</i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              type="select"
                              id="payment_term_id"
                              name="payment_term_id"
                              style={{ textAlign: "right" }}
                              className="form-control"
                              placeholder=""
                              value={payment_term_id}
                              disabled={
                                this.state.disabled
                                  ? true
                                  : this.state.beenPaid == "1"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                this.handleChangeLovs(e);
                              }}
                              required
                            >
                              <option value="" disabled selected>
                                Select
                              </option>
                              {isLoadedlovPaymentsTerms
                                ? paymentsTermsLov.map((itm, index) => {
                                    return (
                                      <option
                                        key={index}
                                        value={itm.PAYMENT_TERM_ID}
                                      >
                                        {itm.NO_OF_DAYS}
                                      </option>
                                    );
                                  })
                                : ""}
                            </Input>
                          </InputGroup>
                        </div>

                        <div className="col-md-2 my-1 input-group d-flex flex-column">
                          <Label style={{ fontWeight: "bold" }}>
                            When is bill due to be paid?
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <div className="d-flex flex-row">
                            <DatePicker
                              className="form-control"
                              wrapperClassName="datePicker"
                              id="due_date"
                              name="due_date"
                              placeholderText="dd-mm-yyyy"
                              disabled={this.state.disabled ? true : false}
                              selected={after_date}
                              dateFormat="dd-MM-yyyy"
                              required
                              onCalendarClose={() => {
                                this.onChangeDatePicker();
                              }}
                            />
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="calended_icon">
                                <i
                                  class="fa fa-calendar-plus-o"
                                  aria-hidden="true"
                                />
                              </InputGroupText>
                            </InputGroupAddon>
                          </div>
                        </div>

                        <div className="col-md-1 my-1">
                          <Label style={{ fontWeight: "bold" }}>
                            Builty No:
                          </Label>
                          <Input
                            type="number"
                            id="builtyno"
                            name="builtyno"
                            className="form-control"
                            style={{ textAlign: "right" }}
                            placeholder=""
                            value={builtyno}
                            disabled={this.state.disabled ? true : false}
                            onChange={this.handleChange}
                          ></Input>
                        </div>

                        <div className="col-md-1 my-1 input-group d-flex flex-column">
                          <Label style={{ fontWeight: "bold" }}>
                            Builty Date:<h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <div className="d-flex flex-row">
                            <DatePicker
                              className="form-control"
                              wrapperClassName="datePicker"
                              id="builtyDate"
                              name="builtyDate"
                              placeholderText="dd-mm-yyyy"
                              disabled={this.state.disabled ? true : false}
                              selected={builtyDate}
                              dateFormat="dd-MM-yyyy"
                              onChange={(e) => {
                                thisContex.setState({ builtyDate: e });
                              }}
                            />
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="calended_icon">
                                <i
                                  class="fa fa-calendar-plus-o"
                                  aria-hidden="true"
                                />
                              </InputGroupText>
                            </InputGroupAddon>
                          </div>
                        </div>

                        <div className="col-md-1">
                          <FormGroup>
                            <Label for="exampleEmail">carrier:</Label>
                            <CreatableSelect
                              isClearable
                              isDisabled={
                                this.state.isLoading || this.state.disabled
                              }
                              name="career"
                              isLoading={this.state.isLoading}
                              onChange={(e) => {
                                this.handleChangeCarrierLovs(e);
                              }}
                              onCreateOption={(e) =>
                                this.handleCreate(e, "career")
                              }
                              options={this.state.careerLov}
                              value={career}
                            />
                          </FormGroup>
                        </div>
                        {this.state.isNayyer || this.state.isEgcpl ? (
                          <div translate="no" className="col-md-2 my-1">
                            <Label
                              // translate="yes"
                              style={{ fontWeight: "bold" }}
                            >
                              I-Tax Filer:
                            </Label>
                            <Select
                              value={filerYn}
                              onChange={this.handleChangeFilerLovs}
                              options={this.state.filerLov}
                              autoFocus
                              isClearable
                              required={
                                this.state.isNayyer || this.state.isEgcpl
                                  ? true
                                  : false
                              }
                              name="selectedOptionPhase"
                              placeholder={select}
                              isDisabled={this.state.disabled ? true : false}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {this.state.formValues.map((element, index) => (
                      <div className="div my-1" key={index}>
                        <div className="InvoiceLine-styling">
                          <div className="col-md-2 col-lg-2 col-xl-2 InvoiceLineHeading">
                            <h6>Invoice Line # {element.lineNum}</h6>
                          </div>
                          <div className="pt-2">
                            <div className="row">
                              <div translate="no" className="col-md-3">
                                <div className="row">
                                  <div className="col-8">
                                    <Label style={{ fontWeight: "bold" }}>
                                      {this.state.itemName}
                                      <h8 style={{ color: "tomato" }}>*</h8>
                                    </Label>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ textAlign: "right" }}
                                  >
                                    <i
                                      class="fa fa-plus"
                                      aria-hidden="true"
                                      title="Add Item"
                                      style={{
                                        color: "green",
                                        cursor: "pointer",
                                        paddingRight: "inherit",
                                      }}
                                      onClick={() => this.itemLoad()}
                                      disabled={
                                        this.state.disabled ? true : false
                                      }
                                    />
                                  </div>
                                </div>
                                <Select
                                  value={element.item_id || ""}
                                  onChange={(e) => {
                                    this.handleChangeItemLovsItem(index, e);
                                  }}
                                  options={itemLov}
                                  autoFocus
                                  isClearable
                                  required
                                  name="item_id"
                                  placeholder={"-- Select --"}
                                  isDisabled={
                                    this.state.disabled ? true : false
                                  }
                                />
                                {ItemError ? (
                                  <h7 style={{ color: "red", fontSize: "75%" }}>
                                    Item is required!
                                  </h7>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="col-md-2">
                                <Label style={{ fontWeight: "bold" }}>
                                  {this.state.qtyName}
                                  <h8 style={{ color: "tomato" }}>*</h8>
                                </Label>
                                <NumberFormat
                                  name="qty"
                                  className="form-control"
                                  style={{ textAlign: "right" }}
                                  thousandSeparator={true}
                                  value={element.qty || ""}
                                  decimalScale={3}
                                  fixedDecimalScale
                                  placeholder="0.000"
                                  onChange={(e) =>
                                    this.handleChangeItem(index, e)
                                  }
                                  disabled={this.state.disabled ? true : false}
                                  required
                           isAllowed={(values) => {
                            const { floatValue } = values;
                          
                            // Empty value allow karo
                            if (floatValue === undefined) {
                              return true;
                            }
                          
                            // Nayyer ya EGCPL ke liye max 3 digits
                            if (this.state.isNayyer || this.state.isEgcpl) {
                              if (floatValue <= 99999) {
                                return true;
                              }
                          
                              swal({
                                title: "Qty Exceed",
                                text: "Qty can't exceed 5 digits",
                                icon: "warning",
                                timer: 2000,
                                buttons: false,
                              });
                          
                              return false;
                            }
                          
                            // Baqi sab companies ke liye unlimited
                            return true;
                          }}
                                />
                                <span style={{ color: "Red" }}>
                                  {element.qtyError}
                                </span>
                                {QuantityError ? (
                                  <h7 style={{ color: "red", fontSize: "75%" }}>
                                    Quantity is required!
                                  </h7>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="col-md-2">
                                <Label style={{ fontWeight: "bold" }}>
                                  {this.state.rateName}:{" "}
                                  <h8 style={{ color: "tomato" }}>*</h8>
                                </Label>
                                <InputGroup className="">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText className="input-tag-text">
                                      {curDesc}
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <NumberFormat
                                    name="rate"
                                    className="form-control"
                                    style={{ textAlign: "right" }}
                                    thousandSeparator={true}
                                    required
                                    placeholder="0.0000"
                                    fixedDecimalScale
                                    decimalScale={4}
                                    value={element.rate || ""}
                                    disabled={
                                      this.state.disabled ? true : false
                                    }
                                    onChange={(e) =>
                                      this.handleChangeItem(index, e)
                                    }
                           isAllowed={(values) => {
  const { floatValue } = values;

  // Empty value allow karo
  if (floatValue === undefined) {
    return true;
  }

  // Nayyer ya EGCPL ke liye max 3 digits
  if (this.state.isNayyer || this.state.isEgcpl) {
    if (floatValue <= 999) {
      return true;
    }

    swal({
      title: "Rate Exceed",
      text: "Rate can't exceed 3 digits",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });

    return false;
  }

  // Baqi sab companies ke liye unlimited
  return true;
}}
                                  />
                                </InputGroup>
                                <span style={{ color: "Red" }}>
                                  {element.rateError}
                                </span>
                                {RateError ? (
                                  <h7 style={{ color: "red", fontSize: "75%" }}>
                                    Rate is required!
                                  </h7>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="col-md-2">
                                <Label style={{ fontWeight: "bold" }}>
                                  {this.state.amountName}:{" "}
                                  <h8 style={{ color: "tomato" }}>*</h8>
                                </Label>
                                <InputGroup className="mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText className="input-tag-text">
                                      {curDesc}
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <NumberFormat
                                    name="amount"
                                    className="form-control"
                                    style={{ textAlign: "right" }}
                                    thousandSeparator={true}
                                    disabled={
                                      this.state.disabled ? true : false
                                    }
                                    value={element.amount || ""}
                                    required
                                    decimalScale={2}
                                    placeholder="0.00"
                                    fixedDecimalScale
                                    onChange={(e) =>
                                      this.handleChangeItem(index, e)
                                    }
                                  />
                                </InputGroup>
                                <span style={{ color: "Red" }}>
                                  {element.amountError}
                                </span>
                              </div>

                              <div className="col-md-2">
                                <Label style={{ fontWeight: "bold" }}>
                                  {this.state.discountName}
                                </Label>
                                <NumberFormat
                                  name="discount"
                                  style={{ textAlign: "right" }}
                                  className="form-control"
                                  thousandSeparator={true}
                                  placeholder="0.00"
                                  decimalScale={2}
                                  fixedDecimalScale
                                  disabled={this.state.disabled ? true : false}
                                  value={element.discount || ""}
                                  onChange={(e) =>
                                    this.handleChangeItem(index, e)
                                  }
                                />
                                <span style={{ color: "Red" }}>
                                  {element.discountError}
                                </span>
                              </div>

                              {isLoadedlovSaleTax ? (
                                <div className="col-md-2">
                                  <Label style={{ fontWeight: "bold" }}>
                                    {this.state.saleTaxName}
                                  </Label>
                                  <Input
                                    type="select"
                                    id="saleTax"
                                    translate="no"
                                    name="saleTax"
                                    className="form-control"
                                    placeholder="Tax % apply"
                                    value={element.saleTax || ""}
                                    disabled={
                                      this.state.disabled ? true : false
                                    }
                                    onChange={(e) => {
                                      this.handleChangeItemLovs(index, e);
                                    }}
                                    required
                                  >
                                    <option value="" disabled>
                                      --Select--
                                    </option>
                                    {isLoadedlovSaleTax
                                      ? saleTaxLov.map((itm, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={itm.STAX_GROUP_ID}
                                            >
                                              {itm.STAX_RATE}%
                                            </option>
                                          );
                                        })
                                      : ""}
                                  </Input>
                                </div>
                              ) : null}

                              <div className="col-md-2">
                                <Label style={{ fontWeight: "bold" }}>
                                  {this.state.netAmountName}
                                </Label>
                                <InputGroup className="mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText className="input-tag-text">
                                      {curDesc}
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <NumberFormat
                                    name="netAmount"
                                    className="form-control"
                                    style={{ textAlign: "right" }}
                                    disabled
                                    required
                                    thousandSeparator={true}
                                    value={element["netAmount"] || ""}
                                    placeholder="0.00"
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                </InputGroup>
                                <span style={{ color: "Red" }}>
                                  {element.netAamountError}
                                </span>
                              </div>

                              {companyName === "Al_Qadir" ||
                              companyName === "AA_Cotton" ? (
                                <div translate="no" className="col-md-2 my-1">
                                  <Label
                                    translate="yes"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Mill No
                                  </Label>
                                  <Input
                                    type="select"
                                    id="millNo"
                                    name="millNo"
                                    className="form-control"
                                    placeholder=""
                                    disabled={
                                      this.state.disabled ? true : false
                                    }
                                    value={element.millNo}
                                    onChange={(e) =>
                                      this.handleChangeDetLovs(
                                        index,
                                        e,
                                        "millNo"
                                      )
                                    }
                                    required
                                  >
                                    <option value="1" selected>
                                      1
                                    </option>
                                    <option value="2">2</option>
                                  </Input>
                                </div>
                              ) : null}

                              <div
                                className="col-md-4"
                                style={{ marginBottom: "20px" }}
                              >
                                <Label style={{ fontWeight: "bold" }}>
                                  {this.state.descriptionName}:
                                  <h8 style={{ color: "tomato" }}>*</h8>
                                </Label>
                                <Input
                                  rows="1"
                                  type="textarea"
                                  id="desc"
                                  name="desc"
                                  className="form-control"
                                  disabled={this.state.disabled ? true : false}
                                  onKeyPress={(e) => {
                                    this.handleMessageBox(index, e);
                                  }}
                                  value={element.desc || ""}
                                  onChange={(e) =>
                                    this.handleChangeItem(index, e)
                                  }
                                ></Input>
                              </div>

                              <div className="col-md-1">
                                <div>
                                  <Button
                                    style={{
                                      background: "#60c9ef",
                                      color: "white",
                                      marginTop: "31px",
                                    }}
                                    className="button add"
                                    type="button"
                                    size="sm"
                                    onClick={() => this.addFormFieldsItem()}
                                    title={tooltipText.addMulLineInv}
                                    hidden={this.state.isNayyer && this.state.fbr_inv_id}
                                    disabled={
                                      this.state.disabled ? true : false
                                    }
                                  >
                                    <i className="fa fa-plus "></i>
                                  </Button>

                                  <Button
                                    style={{
                                      marginTop: "30px",
                                      background: "#ef6062",
                                      color: "white",
                                      marginLeft: "2%",
                                    }}
                                    type="button"
                                    size="sm"
                                    className="button remove"
                                    onClick={() =>
                                      this.removeFormFieldsItem(index)
                                    }
                                    title={tooltipText.remMulLineInv}
                                    disabled={
                                      this.state.disabled ? true : false
                                    }
                                  >
                                    <i className="fa fa-trash "></i>
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.formValues.length > 1 ? (
                          <hr
                            style={{
                              border: "-5px ",
                              marginTop: "7px",
                              borderColor: "E4E5E6",
                            }}
                          />
                        ) : null}
                      </div>
                    ))}

                    {companyName === "Al_Qadir" ? (
                      <div className="InvoiceLine-styling">
                        <div className="col-md-2 col-lg-2 col-xl-2 InvoiceLineHeading">
                          <h6>Delivery Details</h6>
                        </div>
                        <div className="pt-2">
                          <div className="row">
                            <div className="col-md-2 my-1">
                              <Label style={{ fontWeight: "bold" }}>
                                Agent Code:
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                onChange={this.handleChange}
                                id="agentCode"
                                name="agentCode"
                                disabled={this.state.disabled ? true : false}
                                placeholder=""
                                value={agentCode}
                              />
                            </div>
                            <div className="col-md-3 my-1">
                              <Label style={{ fontWeight: "bold" }}>
                                Agent Name:
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                onChange={this.handleChange}
                                id="agentName"
                                name="agentName"
                                disabled={this.state.disabled ? true : false}
                                placeholder=""
                                value={agentName}
                              />
                            </div>
                            <div className="col-md-2 my-1">
                              <Label style={{ fontWeight: "bold" }}>
                                Contact:
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                onChange={this.handleChange}
                                id="agentContract"
                                name="agentContract"
                                disabled={this.state.disabled ? true : false}
                                placeholder=""
                                value={agentContract}
                              />
                            </div>
                            <div className="col-md-2 my-1">
                              <Label style={{ fontWeight: "bold" }}>
                                R.T.No#:
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                onChange={this.handleChange}
                                id="agentRTNo"
                                name="agentRTNo"
                                disabled={this.state.disabled ? true : false}
                                placeholder=""
                                value={agentRTNo}
                              />
                            </div>
                            <div className="col-md-2 my-1">
                              <Label style={{ fontWeight: "bold" }}>
                                Truck Number:
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                onChange={this.handleChange}
                                id="agentTruckNo"
                                name="agentTruckNo"
                                disabled={this.state.disabled ? true : false}
                                placeholder=""
                                value={agentTruckNo}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <hr
                      style={{
                        border: "7px ",
                        marginTop: "14px",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <div className="row">
                      <div className="card-header-Creative-Invoice-Totals col-md-2 col-lg-1 mt-n3 ml-3">
                        <strong>
                          <h5>Total</h5>
                        </strong>
                      </div>
                    </div>

                    <div className="div" style={{ marginTop: "7px" }}>
                      <div className="row">
                        <div className="col-md-2">
                          <Label style={{ fontWeight: "bold" }}>
                            {" "}
                            {this.state.qtyName}
                          </Label>

                          <NumberFormat
                            name="totalqty"
                            className="form-control"
                            disabled
                            thousandSeparator={true}
                            value={totalqty || "0.000"}
                            decimalScale={3}
                            fixedDecimalScale={true}
                            defaultValue="0.000"
                            displayType="input"
                          />
                        </div>
                        <div className="col-md-2">
                          <Label
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            {this.state.amountName}
                          </Label>

                          <NumberFormat
                            name="totalamount"
                            className="form-control"
                            disabled
                            thousandSeparator={true}
                            value={totalamount || "0.00"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            defaultValue="0.00"
                          />
                        </div>
                        <div className="col-md-2">
                          <Label style={{ fontWeight: "bold" }}>
                            {" "}
                            {this.state.discountName}
                          </Label>

                          <NumberFormat
                            name="totaldiscount"
                            className="form-control"
                            disabled
                            thousandSeparator={true}
                            value={totaldiscount || "0.00"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            defaultValue="0.00"
                          />
                        </div>
                        <div className="col-md-2">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.saleTaxName}
                          </Label>

                          <NumberFormat
                            name="salesTax"
                            className="form-control"
                            disabled
                            thousandSeparator={true}
                            value={sumSaleTaxVal || "0.00"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            defaultValue="0.00"
                          />
                        </div>
                        <div className="col-md-2">
                          <Label style={{ fontWeight: "bold" }}>
                            {this.state.netAmountName}
                          </Label>

                          <NumberFormat
                            name="totalnet"
                            className="form-control"
                            disabled
                            thousandSeparator={true}
                            value={totalnet || "0.00"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            defaultValue="0.00"
                          />
                        </div>
                        {this.state.isNayyer || this.state.isEgcpl ? (
                          <>
                            <div className="col-md-2">
                              <Label style={{ fontWeight: "bold" }}>
                                Filer Tax (%)
                              </Label>

                              <NumberFormat
                                name="filerTax"
                                className="form-control"
                                disabled
                                thousandSeparator={true}
                                value={filerTax || "0.00"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                defaultValue="0.00"
                              />
                            </div>
                            <div className="col-md-2">
                              <Label style={{ fontWeight: "bold" }}>
                                Filer Tax Amount
                              </Label>

                              <NumberFormat
                                name="filerTaxAmt"
                                className="form-control"
                                disabled
                                thousandSeparator={true}
                                value={filerTaxAmt || "0.00"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                defaultValue="0.00"
                              />
                            </div>
                            <div className="col-md-2">
                              <Label style={{ fontWeight: "bold" }}>
                                Invoice Net-Total
                              </Label>

                              <NumberFormat
                                name="invNetTotal"
                                className="form-control"
                                disabled
                                thousandSeparator={true}
                                value={invNetTotal || "0.00"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                defaultValue="0.00"
                              />
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {this.state.formValues.length > 1 ? (
                          <hr
                            style={{
                              border: "-5px ",
                              marginTop: "7px",
                              borderColor: "E4E5E6",
                            }}
                          />
                        ) : null}
                      </div>
                    </div>

                    <div>
                      <div className="row  mr-4 mt-2  Submit-Invoice-btn-div">
                        {this.state.copyData ? (
                          <>
                            <Button
                              type="submit"
                              className={[
                                "invoiceSubmitButton",
                                isActive ? "hideShowDiv" : "",
                              ]}
                              id="invoiceButton"
                            >
                              Submit
                            </Button>
                          </>
                        ) : this.props.location.state?.updateCheck === 0 ? (
                          <>
                            <Button
                              type="submit"
                              size="sm"
                              color="success"
                              className={[
                                "invoiceSubmitButton",
                                isActive ? "hideShowDiv" : "",
                              ]}
                              disabled={
                                this.props.location.state?.updateCheck
                                  ? "disabled"
                                  : ""
                              }
                              id="invoiceButton"
                            >
                              Update
                            </Button>
                          </>
                        ) : this.props.location.state?.updateCheck === 2 ? (
                          <>
                            <span>
                              {/* {console.log(
                                "copyInvpermcopyInvperm",
                                copyInvperm
                              )} */}
                              {inv_book_id == 1 && postYn == 1 ? (
                                <>
                                  <Link
                                    to={{
                                      pathname: "/JournalEntryAdd",
                                      state: {
                                        id: this.state.journalId,
                                        updateCheck: 1,
                                      },
                                    }}
                                    hidden={this.state.showJvBtn}
                                  >
                                    <Button
                                      size="sm"
                                      color="warning"
                                      type="button"
                                    >
                                      Show JV
                                    </Button>
                                  </Link>
                                  <Button
                                    disabled={copyInvperm}
                                    size="sm"
                                    color="primary"
                                    className="mr-1 ml-1"
                                    onClick={() => this.copyData()}
                                    // style={inv_book_id == 1 && postYn == 1}
                                    id="copyButton"
                                  >
                                    Copy Invoice
                                  </Button>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                            <span>
                              {" "}
                              {this.state.isAlqadir ||
                              this.state.isNayyer ||
                              this.state.isEgcpl ? (
                                ""
                              ) : (
                                <Button
                                  size="sm"
                                  color="success"
                                  className={[
                                    "invoiceSubmitButton",
                                    this.props.location.state?.updateCheck
                                      ? null
                                      : "hideShowDiv",
                                  ]}
                                  onClick={() => this.funPrintView()}
                                  id="invoiceButton"
                                >
                                  Print
                                </Button>
                              )}
                              {inv_book_id == 1 && postYn == 1 ? (
                                <Button
                                  size="sm"
                                  color="success"
                                  className={[
                                    "invoiceSubmitButton",
                                    this.props.location.state?.updateCheck
                                      ? null
                                      : "hideShowDiv",
                                  ]}
                                  onClick={() => this.paymentHistoryLoad()}
                                  id="invoiceButton"
                                >
                                  Payment History
                                </Button>
                              ) : (
                                ""
                              )}
                            </span>
                          </>
                        ) : this.props.location.state?.idJ ? (
                          ""
                        ) : this.props.location?.rowData ? (
                          ""
                        ) : (
                          <>
                            <Button
                              type="submit"
                              className={[
                                "invoiceSubmitButton",
                                isActive ? "hideShowDiv" : null,
                              ]}
                              disabled={
                                this.props.location.state?.updateCheck
                                  ? "disabled"
                                  : ""
                              }
                              id="invoiceButton"
                            >
                              Submit
                            </Button>
                          </>
                        )}
                        {/* {
                        this.state.show&&
                        <Button
                        color="success">
                          Print
                        </Button> 
                        } */}
                      </div>
                    </div>
                    <br></br>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* model calls on Add New Button to input data for submit data */}
        {beenPaid === "1" ? (
          " "
        ) : (
          <>
            {" "}
            <Modal show={this.state.showModal} size="md" onHide={this.toggle}>
              <Modal.Header
                closeButton
                id="modalHeader"
                className="Creative-Invoice-header-styling p-3"
              >
                <strong>
                  <h4>What To Do Next</h4>
                </strong>
              </Modal.Header>

              <Modal.Body>
                <div className="row rowStyle">
                  <div className="col-md-12">
                    <Button
                      type="submit"
                      color="link" // This applies Bootstrap's link styling
                      className="mr-1"
                      onClick={() => this.modelLinkButton()}
                    >
                      Mark this draft invoice as sent and post it to your
                      account
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </>
        )}
        {/*......... Add Client modal Component call ..................... */}
        {showModalAddNew ? (
          <>
            {/* <ClientForm toggle={this.addToggle} /> */}
            <ClientForm
              toggle={this.addToggle}
              // EditData={this.state.rowData}
              // deleteOption={this.state.deleteOption}
              refreshAllClients={this.refreshData}
            />
          </>
        ) : null}
        {/*......... Add item modal Component call ..................... */}

        {showItemForm ? (
          <>
            <ItemLoadComponent toggle={this.itemLoad} />
          </>
        ) : null}
        {showPaymentHistory ? (
          <>
            <PaymentHistoryComponent
              toggle={this.paymentHistoryLoad}
              invoiceId={this.props.location.state?.id}
              totalNet={this.state.totalnet}
              convRate={this.state.conv_Rate}
              invoiceNumber={this.state.invoiceNumber}
              invoiceDate={this.state.invoice_date}
              customerName={this.state.customerName}
              invBookId="1"
            />
          </>
        ) : null}
      </div>
    );
  }
}
export default CreativeInvoice;
